import { dynamicEnvironment } from "src/app/Common/DynamicEnvironment/DynamicEnvironment";
import { AppointmentScheduleMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/appointment-form/appointment-form.interface";
import { HospitalWingMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-infrastructure/hospital-infrastructure.interface";
import { PatientVisitMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-patient-master/patient-quick-registration/patient-quick-registration.interface";
import { TreatmentPlanMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-treatment-plan/hospital-treatment-plan.interface";
import { HospitalMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-master.interface";
import { HospitalBedMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-wing-detail/hospital-bed/hospital-bed.interface";
import { HospitalRoomMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-wing-detail/hospital-room/hospital-room.interface";
import { HospitalWardMasterDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-wing-detail/hospital-ward/hospital-ward.interface";
import { HospitalInvoiceDetailDTO } from "src/app/hospital/BackOffice/hospital-master/invoice-detail/invoice-detail.interface";
import { TreatmentPlanDetailDTO } from "src/app/hospital/BackOffice/hospital-master/patient-treatment-detail/patient-treatment-detail.interface";
import { HospitalUserAffiliationDTO } from "src/app/hospital/HospitalUserMapping/user-affiliation-mapping.interface";
import { PrescriptionMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescription-master.interface";
import { PrescriptionDiagnosisMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescriptionDetails/prescriptionDiagnosis/prescriptionDiagnosis.interface";
import { PrescriptionMedicationMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescriptionDetails/prescriptionMedication/prescriptionMedication.interface";
import { TreatmentMedicineMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescriptionDetails/treatment-medication/treatment-medication.interface";
import { TreatmentOrderMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescriptionDetails/treatmentOrder/treatmentOrder.interface";
import { VisitComplaintMasterDTO } from "src/app/hospital/interface & services/doctorprescriptionMaster/prescriptionDetails/visitComplaint/visitComplaint.interface";
import { FeedbackMasterDTO } from "src/app/hospital/interface & services/feedbackMaster/feedbackMaster.interface";
import { PatientBedAllocationMappingDTO } from "src/app/hospital/interface & services/patientBedAllocationMapping/patientBedAllocationMapping.interface";
import {
  UserLoginCreateRequestDTO,
  UserLoginDTO,
} from "src/app/login/userlogin.interface";
import { UserMasterDTO } from "src/app/master/users/users.interface";
import { SchoolMasterDTO } from "src/app/School/BackOffice/school-master/school-master.interface";
import { UserAffiliationMappingDTO } from "src/app/School/SchoolUserMapping/user-affiliation-mapping.interface";
import { DocumentVerificationSessionDTO } from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.interface";

export interface ColorObjectI {
  appointmentStatus: string;
  highlightColor: string;
  headerColorStart: string;
  headerColorEnd: string;
  boxBackground: string;
  emailTitle: string;
  statusMessage: string;
  buttonText: string;
  showButton: boolean;
}
function maskAadhaar(aadhaar?: string | null): string {
  if (!aadhaar) return "N/A";

  const digits = aadhaar.replace(/\D/g, "");

  if (digits.length < 4) return "XXXX XXXX XXXX";

  return `XXXX XXXX ${digits.slice(-4)}`;
}

// Full PAN should not be exposed in normal email templates.
function maskPAN(pan?: string | null): string {
  if (!pan) return "N/A";

  const cleanPan = pan.toUpperCase().trim();

  if (cleanPan.length < 4) return "XXXXXXXXXX";

  return `${cleanPan.slice(0, 2)}XXXXXX${cleanPan.slice(-2)}`;
}

export function onboardingEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  loginData: UserLoginCreateRequestDTO,
  
) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Hospital Onboarding Confirmation</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content p {
      margin: 10px 0;
    }
    .credentials {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .credentials p {
      margin: 6px 0;
    }
    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <h1>Welcome to Nishwik Healthcare Network</h1>
    </div>
    <div class="content">
      <h2>Dear <strong>${hospitalInfo.hospitalName}</strong>,</h2>
      <p>We are delighted to inform you that your hospital has been successfully onboarded into the <strong>Nishwik</strong> Healthcare Management System.</p>

      <p>With our platform, you can now streamline hospital operations, manage staff and patient records efficiently, and enhance your overall healthcare management experience.</p>

      <div class="credentials">
        <h3 style="margin:0 0 8px;">Your Login Details</h3>
        <p><strong>Username:</strong> ${loginData.userName}</p>
         <p> <strong>Temporary Password:</strong> ${loginData.userPassword} </p>
      </div>
      <p>Please change your temporary password after your first login.</p>

      <p><strong>Hospital Details:</strong></p>
      <ul>
        <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>City:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
        <li><b>Registration No:</b> ${hospitalInfo.registrationNumber}</li>
      </ul>

      <a href="https://hospital.nishwik.com/" class="button" style="color: white">Go to Dashboard</a>

      <p>If you have any questions or need assistance, feel free to contact our onboarding team at <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.</p>

      <p>Welcome aboard, and thank you for choosing <strong>Nishwik</strong> as your trusted healthcare technology partner.</p>

      <p>Warm regards,<br><strong>The Nishwik Onboarding Team</strong></p>
    </div>
    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | Empowering Healthcare Digitally
    </div>
  </div>
</body>
</html>
`;
}

export function doctorRegistrationEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  userMasterInfo: UserMasterDTO,
  userAffiliationData: HospitalUserAffiliationDTO,
  loginCredentials: UserLoginCreateRequestDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Doctor Registration Confirmation</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content p {
      margin: 10px 0;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .info-box p {
      margin: 6px 0;
    }
    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul {
      padding-left: 18px;
    }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <h1>Welcome to Nishwik Healthcare Network</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>Dr. ${userMasterInfo.firstName} ${
        userMasterInfo.lastName
      }</strong>,</h2>
      <p>
        Congratulations! 🎉 Your registration with <strong>${
          hospitalInfo.hospitalName
        }</strong>
        under the <strong>Nishwik Healthcare Management System</strong> has been
        successfully completed.
      </p>

      <p>
        You can now log in to your doctor dashboard, manage appointments, access
        patient details, update your schedules, and collaborate with your hospital
        team — all in one secure and easy-to-use platform.
      </p>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Your Login Details</h3>
        <p><strong>Username:</strong> ${loginCredentials.userName}</p>
         <p> <strong>Temporary Password:</strong> ${loginCredentials.userPassword}</p>
        <p style="margin-top:10px;"> Please change your temporary password after your first login.</p>
      </div>

      <p><strong>Doctor Profile Details:</strong></p>
      <ul>
        <li><b>Full Name:</b> Dr. ${userMasterInfo.firstName} ${
          userMasterInfo.lastName
        }</li>
        <li><b>Department:</b> ${userAffiliationData.department}</li>
        <li><b>Specialization:</b> ${userAffiliationData.specialization}</li>
        <li><b>Education:</b> ${userAffiliationData.education}</li>
        <li><b>Experience:</b> ${
          userAffiliationData.yearsOfExperience
        } Years</li>
        <li><b>Consultation Fee:</b> ₹${
          userAffiliationData.consultationFee
        }</li>
        <li><b>Registration No:</b> ${
          userAffiliationData.registrationNumber
        }</li>
        <li><b>Licensing Authority:</b> ${
          userAffiliationData.licensingAuthority
        }</li>
        <li><b>Shift Type:</b> ${userAffiliationData.shiftType}</li>
        <li><b>Doctor Degree/License:</b> 
        <a class ="Documentbutton" style="
              display: inline-block;
              margin-top: 2px;
              padding: 1px 10px;
              background-color: #5a3ef2;
              color: #fff;
              border-radius: 6px;
              text-decoration: none;
              font-weight: 500;"  
            href="${userAffiliationData.uploadDocumentUrl}" target="_blank">View</a>
          </li>
        <li><b>Doctor Signature:</b> 
        <a class ="Documentbutton" style="
              display: inline-block;
              margin-top: 5px;
              padding: 1px 10px;
              background-color: #5a3ef2;
              color: #fff;
              border-radius: 6px;
              text-decoration: none;
              font-weight: 500;"  
            href="${userAffiliationData.signatureUrl}" target="_blank">View </a>
           </li>
      </ul>

      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Location:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
      </ul>

      <a href="https://hospital.nishwik.com/" class="button" style="color: white">Login to Doctor Dashboard</a>

      <p>
        If you have any issues logging in or need technical help, please reach out to our
        support team at <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
      </p>

      <p>
        We’re thrilled to have you as part of our healthcare network and look forward
        to empowering your medical journey with technology-driven excellence.
      </p>

      <p>
        Warm regards,<br />
        <strong>The Nishwik Onboarding Team</strong><br />
        <small>“Empowering Healthcare Digitally.”</small>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}


export function adminRegistrationEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  userMasterInfo: UserMasterDTO,

  loginCredentials: UserLoginCreateRequestDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Admin Registration Confirmation</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content p {
      margin: 10px 0;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .info-box p {
      margin: 6px 0;
    }
    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul {
      padding-left: 18px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <div class="header">
      <h1>Welcome to Nishwik Healthcare Admin Portal</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>${userMasterInfo.firstName} ${userMasterInfo.lastName}</strong>,</h2>

      <p>
        Congratulations! 🎉 Your <strong>Admin account</strong> for 
        <strong>${hospitalInfo.hospitalName}</strong> has been successfully created
        under the <strong>Nishwik Healthcare Management System</strong>.
      </p>

      <p>
        You can now log in to the admin dashboard to manage hospital operations,
        doctors, patients, appointments, billing, wards, rooms, beds, reports,
        and other hospital management activities.
      </p>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Your Login Details</h3>
        <p><strong>Username:</strong> ${loginCredentials.userName}</p>
         <p>
    <strong>Temporary Password:</strong> ${loginCredentials.userPassword}</p>
     <p style="margin-top:10px;">Please change your temporary password after your first login.</p>
       
      </div>

      <p><strong>Admin Profile Details:</strong></p>
      <ul>
        <li><b>Full Name:</b> ${userMasterInfo.firstName} ${userMasterInfo.lastName}</li>
        <li><b>Email:</b> ${userMasterInfo.emailId}</li>
        <li><b>Mobile No:</b> ${userMasterInfo.mobileNo}</li>
        <li><b>Role:</b> Hospital Admin</li>
      </ul>

      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Location:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${hospitalInfo.country}</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
      </ul>

      <a href=${dynamicEnvironment.websiteURL} class="button" style="color: white">
        Login to Admin Dashboard
      </a>

      <p>
        If you have any issues logging in or need technical help, please reach out to our
        support team at <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
      </p>

      <p>
        Warm regards,<br />
        <strong>The Nishwik Onboarding Team</strong><br />
        <small>“Empowering Healthcare Digitally.”</small>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function staffRegistrationEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  staff: any,
  loginCredentials: UserLoginCreateRequestDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>New Staff Registration</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content p {
      margin: 10px 0;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .info-box p {
      margin: 6px 0;
    }
    ul {
      padding-left: 18px;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
          .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <div class="header">
      <h1>New Staff Member Added</h1>
    </div>

    <div class="content">
      <h2>New Staff Registration Completed</h2>

      <p>
        A new staff member has been successfully registered under 
        <strong>${hospitalInfo.hospitalName}</strong>.
      </p>

      <p>
        Below are the details of the newly added staff:
      </p>

            <div class="info-box">
        <h3 style="margin:0 0 8px;">Your Login Details</h3>
        <p><strong>Username:</strong> ${loginCredentials.userName}</p>
         <p>
    <strong>Temporary Password:</strong> ${loginCredentials.userPassword}</p>
     <p style="margin-top:10px;">Please change your temporary password after your first login.</p>
      </div>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Staff Details</h3>
        <p><strong>Full Name:</strong> ${staff.firstName} ${
          staff.middleName || ""
        } ${staff.lastName}</p>
        <p><strong>Gender:</strong> ${staff.gender}</p>
        <p><strong>Date of Birth:</strong> ${staff.dob}</p>
        <p><strong>Blood Group:</strong> ${staff.bloodGroup || "N/A"}</p>
        <p><strong>Mobile No:</strong> ${staff.mobileNo}</p>
        <p><strong>Email ID:</strong> ${staff.emailId}</p>
      </div>

      <p><strong>Professional Information:</strong></p>
      <ul>
        <li><b>Department:</b> ${staff.department}</li>
        <li><b>Specialization:</b> ${staff.specialization}</li>
        <li><b>Highest Education:</b> ${staff.highestEducation}</li>
        <li><b>Employment Type:</b> ${staff.employmentType}</li>
        <li><b>Experience:</b> ${staff.yearsOfExperience} Years</li>
        <li><b>Shift Type:</b> ${staff.shiftType}</li>
      </ul>

      <p><strong>Address Details:</strong></p>
      <ul>
        <li><b>Address:</b> ${staff.address}</li>
        <li><b>City:</b> ${staff.city}</li>
        <li><b>State:</b> ${staff.state}</li>
        <li><b>Country:</b> ${staff.country}</li>
        <li><b>Pincode:</b> ${staff.pincode}</li>
      </ul>

      <p><strong>Guardian / Emergency Contact:</strong></p>
      <ul>
        <li><b>Guardian Name:</b> ${staff.guardianName}</li>
        <li><b>Guardian Mobile:</b> ${staff.guardianMobileNo}</li>
      </ul>

      <p><strong>Identity & Licensing:</strong></p>
      <ul>
        <li><b>Aadhaar:</b> ${maskAadhaar(staff.aadharNumber)}</li>
        <li><b>PAN:</b>  ${maskPAN(staff.panNumber)}</li>
        <li><b>Registration No:</b> ${staff.registrationNumber}</li>
        <li><b>Licensing Authority:</b> ${staff.licensingAuthority}</li>
        <li><b>Year of Registration:</b> ${staff.yearOfRegistration}</li>
      </ul>

      <a href="https://hospital.nishwik.com/" class="button" style="color: white">Login to Staff Dashboard</a>

      <p>
        If any correction or update is needed for the newly added staff,
        please log in to the hospital admin portal and modify the details.
      </p>

      <p>
        Warm regards,<br />
        <strong>Nishwik Hospital Management System</strong>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function patientRegistrationEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  patientInfo: any,
  loginCredentials: any,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Patient Registration Confirmation</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul { padding-left: 18px; }
        .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
  </style>
</head>

<body>
  <div class="email-container">

    <div class="header">
      <h1>Welcome to ${hospitalInfo.hospitalName}</h1>
    </div>

    <div class="content">

      <h2>Dear <strong>${patientInfo.firstName} ${
        patientInfo.lastName
      }</strong>,</h2>

      <p>
        We are delighted to inform you that your registration with 
        <strong>${hospitalInfo.hospitalName}</strong> under the 
        <strong>Nishwik Healthcare Management System</strong> has been 
        successfully completed.
      </p>

      <p>
        Your patient profile has been securely added to our digital healthcare 
        system. You can now access your personal dashboard, book appointments, 
        view medical history, and manage your health records online.
      </p>

      <!-- Login Credentials -->
      <div class="info-box">
        <h3 style="margin:0 0 8px;">Your Login Details</h3>
        <p><strong>Username:</strong> ${loginCredentials.userName}</p>
         <p>
       <strong>Temporary Password:</strong> ${loginCredentials.userPassword}</p>
       <p style="margin-top:10px;">You will be asked to change your password on first login.</p>
      </div>

      <!-- Patient Profile -->
      <p><strong>Patient Profile Details:</strong></p>
      <ul>
        <li><b>Full Name:</b> ${patientInfo.firstName} ${
          patientInfo.lastName
        }</li>
        <li><b>Date of Birth:</b> ${patientInfo.dob}</li>
        <li><b>Gender:</b> ${patientInfo.gender}</li>
        <li><b>Blood Group:</b> ${patientInfo.bloodGroup || "N/A"}</li>
        <li><b>Contact:</b> ${patientInfo.mobileNo}</li>
        <li><b>Email:</b> ${patientInfo.emailId}</li>
        <li><b>Guardian Name:</b> ${patientInfo.guardianName}</li>
        <li><b>Guardian Contact:</b> ${patientInfo.guardianMobileNo}</li>
        <li><b>Address:</b> ${patientInfo.address}, ${patientInfo.city}, ${
          patientInfo.state
        }, ${patientInfo.country}</li>
        <li><b>Pincode:</b> ${patientInfo.pinCode}</li>
        <li><b>Aadhaar No:</b> ${maskAadhaar(patientInfo.aadharNumber)}</li>
        <li><b>PAN No:</b> ${maskPAN(patientInfo.panNumber)}</li>
        <li><b>Marital Status:</b> ${patientInfo.meritalStatus}</li>
        <li><b>Referred By:</b> ${patientInfo.referredBy || "N/A"}</li>
        <li><b>Allergies:</b> ${patientInfo.allergies || "None"}</li>
        <li><b>Chronic Conditions:</b> ${
          patientInfo.chronicCondition || "None"
        }</li>
      </ul>

      <!-- Hospital Info -->
      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Location:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
      </ul>

      <a href="https://hospital.nishwik.com/" class="button" style="color: white">Patient Login</a>

      <!-- Support -->
      <p>
        For any assistance regarding login or your health records, please reach us at  
        <a href="mailto:${hospitalInfo.email}">${hospitalInfo.email}</a>.
      </p>

      <p>
        We are committed to providing you with safe, seamless, and patient-centric care.
      </p>

      <p>
        Warm regards,<br />
        <strong>The Nishwik Healthcare Team</strong><br />
        <small>“Empowering Healthcare Digitally.”</small>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>

  </div>
</body>
</html>
`;
}

export function appointmentStatusUpdateEmailTemplate(
  colorAndTitleObject: ColorObjectI,
  hospitalInfo: HospitalMasterDTO,
  appointmentInfo: AppointmentScheduleMasterDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${colorAndTitleObject.emailTitle}</title>

  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }

    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }

    .header {
      background: linear-gradient(90deg, ${
        colorAndTitleObject.headerColorStart
      }, ${colorAndTitleObject.headerColorEnd});
      color: #fff;
      text-align: center;
      padding: 25px;
    }

    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }

    .content {
      padding: 30px;
      line-height: 1.6;
    }

    .content h2 {
      color: ${colorAndTitleObject.highlightColor};
      font-size: 20px;
      margin-bottom: 10px;
    }

    .info-box {
      background: ${colorAndTitleObject.boxBackground};
      border-left: 4px solid ${colorAndTitleObject.highlightColor};
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }

    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: ${colorAndTitleObject.highlightColor};
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }

    ul { padding-left: 18px; }
    .footer {
      background: ${colorAndTitleObject.boxBackground};
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <div class="header">
      <h1>${colorAndTitleObject.emailTitle}</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>${appointmentInfo.patientName}</strong>,</h2>

      <p>
        Your appointment has been 
        <strong style="color: ${colorAndTitleObject.highlightColor}">${
          colorAndTitleObject.appointmentStatus
        }</strong> 
        at <strong>${hospitalInfo.hospitalName}</strong>.
      </p>

      <p>${colorAndTitleObject.statusMessage}</p>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Appointment Details</h3>
        <p><strong>Token No:</strong> ${appointmentInfo.tokenNo}</p>
        <p><strong>Date:</strong> ${appointmentInfo.appointmentDate}</p>
        <p><strong>Time:</strong> ${appointmentInfo.appointmentTime}</p>
        <p><strong>Duration:</strong> ${
          appointmentInfo.appointmentDuration
        } Minutes</p>
        <p><strong>Consultation Mode:</strong> ${
          appointmentInfo.consultationMode
        }</p>
        <p><strong>First Visit:</strong> ${
          appointmentInfo.isFirstVisit ? "Yes" : "Regular"
        }</p>
      </div>

      <p><strong>Doctor Information:</strong></p>
      <ul>
        <li><b>Name:</b> Dr. ${appointmentInfo.doctorName}</li>
      </ul>

      <p><strong>Service Selected:</strong></p>
      <ul>
        <li><b>Service Name:</b> ${appointmentInfo.serviceName}</li>
      </ul>

      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Address:</b> ${hospitalInfo.address}</li>
        <li><b>Location:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
      </ul>

      ${
        colorAndTitleObject.showButton
          ? `
      <a href="https://hospital.nishwik.com/" class="button" style="color: white">
        ${colorAndTitleObject.buttonText}
      </a>`
          : ""
      }

      <p>
        For assistance, contact us at 
        <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
      </p>

      <p>
        Warm regards,<br />
        <strong>The Nishwik Appointment Team</strong><br />
        <small>“Empowering Healthcare Digitally.”</small>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function onFeedbackEmailTemplate(
  feedback: FeedbackMasterDTO,
  user: UserMasterDTO,
  hospital: HospitalMasterDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>New Feedback Received</title>

<style>
  body { font-family: 'Segoe UI', Roboto, Arial, sans-serif; margin:0; padding:0; background:#f5f3ff; color:#333; }
  .email-container { max-width:680px; margin:40px auto; background:#fff; border-radius:12px; 
    box-shadow:0 4px 12px rgba(0,0,0,0.05); overflow:hidden; }
  .header { background:linear-gradient(90deg,#5a3ef2,#a16eff); padding:24px; text-align:center; color:#fff; }
  .header h1 { margin:0; font-size:22px; font-weight:600; }
  .content { padding:28px 30px; line-height:1.6; }
  .section-title { margin-top:20px; color:#5a3ef2; font-weight:600; font-size:18px; }
  .info-box { background:#f7f5ff; padding:15px 18px; border-left:4px solid #5a3ef2; border-radius:8px;
    margin-top:10px; margin-bottom:20px; }
  .footer { text-align:center; font-size:13px; background:#f1ecff; padding:14px; color:#555; }
</style>
</head>

<body>

<div class="email-container">
  <div class="header">
    <h1>New Feedback Submission</h1>
  </div>

  <div class="content">
    <p>A new feedback has been submitted. Below are the important details:</p>

    <!-- FEEDBACK DETAILS -->
    <div class="section-title">Feedback Details</div>
    <div class="info-box">
      <p><strong>Submitted By:</strong> ${feedback.masterType}</p>
      <p><strong>Rating:</strong> ${feedback.rating} &#11088;</p>
      <p><strong>Experience Level:</strong> ${feedback.experienceLevel}</p>
      <p><strong>Feedback Summary:</strong><br>${
        feedback.description || "N/A"
      }</p>
    </div>

    <!-- USER INFORMATION -->
    <div class="section-title">User Information</div>
    <div class="info-box">
      <p><strong>Name:</strong> ${user.firstName} ${user.lastName}</p>
      ${
        user.designation
          ? `<p><strong>Designation:</strong> ${user.designation}</p>`
          : ""
      }
      <p><strong>Email:</strong> ${user.emailId}</p>
      <p><strong>Mobile:</strong> ${user.mobileNo}</p>
      ${user.city ? `<p><strong>City:</strong> ${user.city}</p>` : ""}
      ${user.state ? `<p><strong>State:</strong> ${user.state}</p>` : ""}
      ${user.country ? `<p><strong>Country:</strong> ${user.country}</p>` : ""}
    </div>

    <!-- HOSPITAL INFORMATION -->
    <div class="section-title">Hospital Information</div>
    <div class="info-box">
      <p><strong>Hospital Name:</strong> ${hospital.hospitalName}</p>
      <p><strong>Hospital Code:</strong> ${hospital.hospitalCode}</p>
      <p><strong>Email:</strong> ${hospital.email}</p>
      <p><strong>Contact:</strong> ${hospital.contactNumber}</p>
      <p><strong>Address:</strong> ${hospital.address}</p>
      <p><strong>Location:</strong> 
        ${hospital.city}, ${hospital.state}, ${hospital.country}
      </p>
    </div>

    <p>You may log in to the admin panel to review and take further action.</p>
    <p>Regards,<br><strong>Nishwik Healthcare System</strong></p>
  </div>

  <div class="footer">
    © 2025 Nishwik | All Rights Reserved
  </div>
</div>

</body>
</html>
`;
}

export function patientBedAllocationEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  wingInfo: HospitalWingMasterDTO,
  wardInfo: HospitalWardMasterDTO,
  roomInfo: HospitalRoomMasterDTO,
  bedInfo: HospitalBedMasterDTO,
  allocationInfo: PatientBedAllocationMappingDTO,
  patientInfo: UserMasterDTO,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Bed Allocation Confirmation</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .charges-box {
      background: #fff9f4;
      border-left: 4px solid #ff9800;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul { padding-left: 18px; }
  </style>
</head>

<body>
  <div class="email-container">
    <div class="header">
      <h1>Bed Allocation Confirmation</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>${
        patientInfo.firstName + " " + patientInfo.lastName
      }</strong>,</h2>
      <p>
        We are pleased to inform you that a hospital bed has been successfully
        allocated for your admission at <strong>${
          hospitalInfo.hospitalName
        }</strong>.
      </p>

      <p>Please find your allocation details below:</p>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Bed Allocation Details</h3>
        <p><strong>Allocation Date:</strong> ${allocationInfo.occupiedFrom}</p>
        <p><strong>Wing:</strong> ${wingInfo.wingName} (${
          wingInfo.wingCode
        })</p>
        <p><strong>Ward:</strong> ${wardInfo.wardName} (${
          wardInfo.wardCode
        })</p>
        <p><strong>Ward Type:</strong> ${wardInfo.wardType}</p>
        <p><strong>Room Type:</strong> ${roomInfo.roomType}</p>
        <p><strong>Room Number:</strong> ${roomInfo.roomNumber}</p>
        <p><strong>Bed Number:</strong> ${bedInfo.bedNumber}</p>
        <p><strong>Bed Type:</strong> ${bedInfo.bedType}</p>
      </div>

      <div class="charges-box">
        <h3 style="margin:0 0 8px;">Bed Charges Summary</h3>
        <p><strong>Base Charge:</strong> ₹${bedInfo.baseCharge.toFixed(2)}</p>
        <p><strong>Tax (${
          bedInfo.taxPercentage
        }%):</strong> ₹${bedInfo.taxAmount.toFixed(2)}</p>
        <p><strong>Total Charge:</strong> <b>₹${bedInfo.totalCharge.toFixed(
          2,
        )}</b></p>
      </div>

      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Location:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
      </ul>

      <p>
        For assistance, feel free to reach us at 
        <a href="mailto:${hospitalInfo.email}">${hospitalInfo.email}</a>.
      </p>

      <p>
        Wishing you a comfortable stay and a speedy recovery.<br>
        Warm regards,<br>
        <strong>${hospitalInfo.hospitalName} Team</strong>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} ${
        hospitalInfo.hospitalName
      } | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function documentUploadEmailToHospitalAdmin(
  hospitalInfo: HospitalMasterDTO,
  documentVerificationSessionData: DocumentVerificationSessionDTO,
  sessionId: string,
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  return `
  <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Hospital Document Upload Request</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .content p {
      margin: 10px 0;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .info-box p {
      margin: 6px 0;
    }
    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul {
      padding-left: 18px;
    }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <h1>Hospital Document Verification Required</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>${hospitalInfo.hospitalName}</strong>,</h2>

      <p>
        Thank you for registering with the <strong>Nishwik Healthcare Management System</strong>.
        To complete your onboarding and activate your hospital dashboard, we kindly request
        you to upload the mandatory legal and compliance documents for verification.
      </p>

      <p>
        These documents are essential for validating your hospital’s authenticity, government
        compliance, and operational approvals. Our team will begin verification immediately
        after the documents are uploaded.
      </p>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Document Upload Request Details</h3>
        <p><strong>Request Raised On:</strong> ${formatDate(
          documentVerificationSessionData.generatedOn.toString(),
        )}</p>
        <p><strong>Expires On:</strong> ${formatDate(
          documentVerificationSessionData.expiresOn.toString(),
        )}</p>
        <p style="margin-top:8px; color:#a33;">
          Note: The document upload link is valid for the next <strong>24 hours only</strong>.
          After expiration, you must request a new verification link.
        </p>
      </div>

      <div class="info-box">
        <h3 style="margin:0 0 8px;">Documents Required for Verification</h3>
        <ul>
          <li><b>PAN Card</b> – Verify PAN matches hospital name</li>
          <li><b>GST Certificate</b> – Should match PAN number and registered address</li>
          <li><b>Hospital Registration Certificate</b> – Check registration number, name & address</li>
          <li><b>Fire NOC</b> – Validate name and expiry</li>
          <li><b>Biomedical Waste Certificate</b> – Check issuing authority & validity</li>
          <li><b>Pharmacy License</b> <span style="color:#777;">(Optional)</span></li>
        </ul>
      </div>

      <p>You can upload all documents using the link below:</p>

      <a href="${dynamicEnvironment.websiteURL}/hospital-document-upload/${sessionId}/${
        hospitalInfo.hospitalId
      }" class="button" style="color:white;">Upload Hospital Documents</a>

      <p>
        Once submitted, our compliance team will verify your documents within
        <strong>24–48 hours</strong>. If any clarification is needed, we will reach out via email.
      </p>

      <p><strong>Hospital Information:</strong></p>
      <ul>
        <li><b>Name:</b> ${hospitalInfo.hospitalName}</li>
        <li><b>Description:</b> ${hospitalInfo.hospitalDesc}</li>
        <li><b>Address:</b> ${hospitalInfo.address}</li>
        <li><b>City:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${
          hospitalInfo.country
        }</li>
        <li><b>Email:</b> ${hospitalInfo.email}</li>
        <li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
        <li><b>Registration Number:</b> ${hospitalInfo.registrationNumber}</li>
      </ul>

      <p>
        If you face any upload issues or need technical help,
        feel free to reach us at
        <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
      </p>

      <p>
        We appreciate your cooperation and look forward to completing
        your hospital onboarding process.
      </p>

      <p>
        Warm regards,<br/>
        <strong>The Nishwik Onboarding Team</strong><br/>
        <small>“Empowering Healthcare Digitally.”</small>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
  `;
}

//  Re Send Rejected Document School  ////

export function schoolDocumentRejectionEmailTemplate(
  schoolInfo: SchoolMasterDTO,
  documentVerificationSessionData: DocumentVerificationSessionDTO,
  sessionId: string,
  rejectedDocuments: string[],
  rejectReasons: string | string[] = [],
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  const readableName = (doc: string) => {
    const cleanDoc = (doc || "").trim();

    if (!cleanDoc) return "View Document";

    const fileName = cleanDoc.split("/").pop()?.split("?")[0] || cleanDoc;

    try {
      return decodeURIComponent(fileName)
        .replaceAll("-", " ")
        .replaceAll("_", " ");
    } catch {
      return fileName.replaceAll("-", " ").replaceAll("_", " ");
    }
  };

  const getRejectedDocumentUrl = (doc: string) => {
    const cleanDoc = (doc || "").trim();

    if (!cleanDoc) return "";

    if (cleanDoc.startsWith("http://") || cleanDoc.startsWith("https://")) {
      return encodeURI(cleanDoc);
    }

    const cleanRelativePath = cleanDoc.startsWith("/")
      ? cleanDoc.substring(1)
      : cleanDoc;

    if (cleanRelativePath.toLowerCase().startsWith("uploads/")) {
      return encodeURI(`https://dev.apig.nishwik.com/${cleanRelativePath}`);
    }

    return encodeURI(`https://dev.apig.nishwik.com/Uploads/${cleanRelativePath}`);
  };

  const rejectedDocumentsHtml = rejectedDocuments
    .filter((d) => d && d.trim())
    .map((d) => {
      const documentUrl = getRejectedDocumentUrl(d);
      const documentName = readableName(d);

      return `
        <li style="margin:6px 0;">
          <a href="${documentUrl}" target="_blank" style="color:#1a73e8; text-decoration:underline; font-weight:600;">
            ${documentName || "View Document"}
          </a> — Invalid / mismatched / unclear document
        </li>`;
    })
    .join("");

  const reasonsArray: string[] = Array.isArray(rejectReasons)
    ? rejectReasons.filter((r) => r && r.trim())
    : rejectReasons && rejectReasons.trim()
    ? [rejectReasons.trim()]
    : [];

  function buildReasonsBlock(): string {
    if (reasonsArray.length === 0) return "";

    if (reasonsArray.length === 1) {
      return `
        <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
          <strong style="color:#d93025;">Reason for Rejection:</strong>
          <p style="margin:6px 0 0; color:#333;">${reasonsArray[0]}</p>
        </div>`;
    }

    const items = reasonsArray
      .map(
        (r, i) =>
          `<li style="margin:6px 0; color:#333;"><strong>Rejection ${
            i + 1
          }:</strong> ${r}</li>`,
      )
      .join("");

    return `
      <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
        <strong style="color:#d93025;">Reasons for Rejection (${reasonsArray.length} documents rejected):</strong>
        <ol style="margin:8px 0 0; padding-left:18px;">
          ${items}
        </ol>
      </div>`;
  }

  return `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>School Document Verification Failed</title>

<style>
body {
  font-family: 'Segoe UI', Roboto, Arial, sans-serif;
  background: linear-gradient(135deg, #fff4f4, #ffffff);
  color: #333;
  margin: 0;
  padding: 0;
}
.email-container {
  max-width: 700px;
  margin: 40px auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.header {
  background: linear-gradient(90deg, #d93025, #ff6b6b);
  color: #fff;
  text-align: center;
  padding: 25px;
}
.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
.content {
  padding: 30px;
  line-height: 1.6;
}
.content h2 {
  color: #d93025;
  font-size: 20px;
  margin-bottom: 10px;
}
.info-box {
  background: #fff5f5;
  border-left: 4px solid #d93025;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
}
.button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #d93025;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}
.footer {
  background: #fff1f1;
  color: #666;
  text-align: center;
  font-size: 13px;
  padding: 15px;
}
ul {
  padding-left: 18px;
}
</style>
</head>

<body>
<div class="email-container">

<div class="header">
<h1>School Document Verification Failed</h1>
</div>

<div class="content">

<h2>Dear <strong>${schoolInfo.schoolName}</strong>,</h2>

${buildReasonsBlock()}

<p>
Thank you for submitting your documents to the <strong>Nishwik School Management System</strong>.
After reviewing your uploaded files, our compliance team found issues with one or more documents.
Therefore, your school verification process <strong>could not be completed</strong>.
</p>

<div class="info-box">
<h3 style="margin:0 0 8px;">Verification Attempt Details</h3>
<p><strong>Reviewed On:</strong> ${formatDate(
    documentVerificationSessionData.generatedOn.toString(),
  )}</p>
<p><strong>Status:</strong> <span style="color:#d93025;font-weight:600;">Rejected</span></p>
<p style="margin-top:8px;">
You must correct and re-upload the rejected documents to continue onboarding.
</p>
</div>

<div class="info-box">
<h3 style="margin:0 0 8px;">Rejected Documents</h3>

${
  rejectedDocumentsHtml
    ? `<ul style="margin:8px 0 0;">${rejectedDocumentsHtml}</ul>`
    : `<h4 style="color:#a33">Kindly use the "Re-Upload Documents" button below to review and re-upload the rejected documents.</h4>`
}

<p style="margin-top:8px; color:black;">
Please ensure the documents are clear, valid, unexpired, and match school details before uploading again.
</p>
</div>

<p>You can re-upload the corrected documents using the secure link below:</p>

<a href="${dynamicEnvironment.websiteURL}/school-document-upload/${sessionId}/${schoolInfo.schoolId}" class="button" style="color:white;">
Re-Upload Documents
</a>

<p>
The link will remain valid for <strong>24 hours</strong>. After expiration, you must request a new upload link.
</p>

<p><strong>School Information:</strong></p>
<ul>
<li><b>Name:</b> ${schoolInfo.schoolName}</li>
<li><b>Address:</b> ${schoolInfo.address}</li>
<li><b>City:</b> ${schoolInfo.city}</li>
<li><b>State:</b> ${schoolInfo.state}</li>
<li><b>Pincode:</b> ${schoolInfo.pincode}</li>
<li><b>Email:</b> ${schoolInfo.email}</li>
<li><b>Phone Number:</b> ${schoolInfo.phoneNo}</li>
<li><b>Affiliation Number:</b> ${schoolInfo.affiliationNumber}</li>
<li><b>Board:</b> ${schoolInfo.boardName}</li>
</ul>

<p>
If you believe this rejection is incorrect or need assistance,
contact us at
<a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
</p>

<p>
We look forward to helping you successfully complete onboarding.
</p>

<p>
Regards,<br/>
<strong>Nishwik Compliance Team</strong><br/>
<small>School Verification Department</small>
</p>

</div>

<div class="footer">
© ${new Date().getFullYear()} Nishwik | All Rights Reserved
</div>

</div>
</body>
</html>
`;
}

//  Re Send Rejected Document Hospital  ////

export function documentRejectionEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  documentVerificationSessionData: DocumentVerificationSessionDTO,
  sessionId: string,
  rejectedDocuments: string[],
  rejectReasons: string | string[] = [],
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  const readableName = (doc: string) => {
    const cleanDoc = (doc || "").trim();
    const fileName = cleanDoc.split("/").pop()?.split("?")[0] || cleanDoc;
    return fileName.replaceAll("-", " ");
  };

  const getRejectedDocumentUrl = (doc: string) => {
    const cleanDoc = (doc || "").trim();

    if (!cleanDoc) return "";

    if (cleanDoc.startsWith("http://") || cleanDoc.startsWith("https://")) {
      return encodeURI(cleanDoc);
    }

    return encodeURI(`https://dev.apig.nishwik.com/Uploads/${cleanDoc}`);
  };

  const rejectedDocumentsHtml = rejectedDocuments
    .map((d) => {
      const documentUrl = getRejectedDocumentUrl(d);
      const documentName = readableName(d);

      return `
        <li style="margin:6px 0;">
          <a href="${documentUrl}" target="_blank" style="color:#1a73e8; text-decoration:underline; font-weight:600;">
            ${documentName || "View Document"}
          </a> — Invalid / mismatched / unclear document
        </li>`;
    })
    .join("");

  // Normalise rejectReasons to array
  const reasonsArray: string[] = Array.isArray(rejectReasons)
    ? rejectReasons.filter((r) => r && r.trim())
    : rejectReasons && rejectReasons.trim()
    ? [rejectReasons.trim()]
    : [];

  function buildReasonsBlock(): string {
    if (reasonsArray.length === 0) return "";

    if (reasonsArray.length === 1) {
      return `
        <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
          <strong style="color:#d93025;">Reason for Rejection:</strong>
          <p style="margin:6px 0 0; color:#333;">${reasonsArray[0]}</p>
        </div>`;
    }

    const items = reasonsArray
      .map(
        (r, i) =>
          `<li style="margin:6px 0; color:#333;"><strong>Rejection ${i + 1}:</strong> ${r}</li>`,
      )
      .join("");

    return `
      <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
        <strong style="color:#d93025;">Reasons for Rejection (${reasonsArray.length} documents rejected):</strong>
        <ol style="margin:8px 0 0; padding-left:18px;">
          ${items}
        </ol>
      </div>`;
  }

  return `
<!DOCTYPE html>

<html lang="en">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>Hospital Document Verification Failed</title>
<style>
body {
  font-family: 'Segoe UI', Roboto, Arial, sans-serif;
  background: linear-gradient(135deg, #fff4f4, #ffffff);
  color: #333;
  margin: 0;
  padding: 0;
}
.email-container {
  max-width: 700px;
  margin: 40px auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.header {
  background: linear-gradient(90deg, #d93025, #ff6b6b);
  color: #fff;
  text-align: center;
  padding: 25px;
}
.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
.content {
  padding: 30px;
  line-height: 1.6;
}
.content h2 {
  color: #d93025;
  font-size: 20px;
  margin-bottom: 10px;
}
.info-box {
  background: #fff5f5;
  border-left: 4px solid #d93025;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
}
.button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #d93025;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}
.footer {
  background: #fff1f1;
  color: #666;
  text-align: center;
  font-size: 13px;
  padding: 15px;
}
ul {
  padding-left: 18px;
}
</style>
</head>

<body>
<div class="email-container">

<div class="header">
<h1>Document Verification Failed</h1>
</div>

<div class="content">

<h2>Dear <strong>${hospitalInfo.hospitalName}</strong>,</h2>

      ${buildReasonsBlock()}

<p>
Thank you for submitting your documents to the <strong>Nishwik Healthcare Management System</strong>.
After reviewing your uploaded files, our compliance team found issues with one or more documents.
Therefore, your hospital verification process <strong>could not be completed</strong>.
</p>

<div class="info-box">
<h3 style="margin:0 0 8px;">Verification Attempt Details</h3>
<p><strong>Reviewed On:</strong> ${formatDate(
    documentVerificationSessionData.generatedOn.toString(),
  )}</p>
<p><strong>Status:</strong> <span style="color:#d93025;font-weight:600;">Rejected</span></p>
<p style="margin-top:8px;">
You must correct and re-upload the rejected documents to continue onboarding.
</p>
</div>

<div class="info-box">
<h3 style="margin:0 0 8px;">Rejected Documents</h3>

${
  rejectedDocumentsHtml
    ? `<ul style="margin:8px 0 0;">${rejectedDocumentsHtml}</ul>`
    : `<h4 style="color:#a33">Kindly use the "Re-Upload Documents" button below to review and re-upload the rejected documents.</h4>`
}

<p style="margin-top:8px; color:black;">
Please ensure the documents are clear, valid, unexpired, and match hospital details before uploading again.
</p>
</div>

<p>You can re-upload the corrected documents using the secure link below:</p>

<a href="${dynamicEnvironment.websiteURL}/hospital-document-upload/${sessionId}/${hospitalInfo.hospitalId}" class="button" style="color:white;">
Re-Upload Documents
</a>

<p>
The link will remain valid for <strong>24 hours</strong>. After expiration, you must request a new upload link.
</p>

<p><strong>Hospital Information:</strong></p>
<ul>
<li><b>Name:</b> ${hospitalInfo.hospitalName}</li>
<li><b>Address:</b> ${hospitalInfo.address}</li>
<li><b>City:</b> ${hospitalInfo.city}, ${hospitalInfo.state}, ${hospitalInfo.country}</li>
<li><b>Email:</b> ${hospitalInfo.email}</li>
<li><b>Contact:</b> ${hospitalInfo.contactNumber}</li>
<li><b>Registration Number:</b> ${hospitalInfo.registrationNumber}</li>
</ul>

<p>
If you believe this rejection is incorrect or need assistance,
contact us at
<a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
</p>

<p>
We look forward to helping you successfully complete onboarding.
</p>

<p>
Regards,<br/>
<strong>Nishwik Compliance Team</strong><br/>
<small>Healthcare Verification Department</small>
</p>

</div>

<div class="footer">
© ${new Date().getFullYear()} Nishwik | All Rights Reserved
</div>

</div>
</body>
</html>

  `;
}

export function onboardingDocumentUploadIssue(
  issue: string,
  hospitalInfo: HospitalMasterDTO,
  userInfo: any,
  uploadedImageURL: string | null,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Hospital Document Upload Issue</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: #ffffff;
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 30px auto;
      background: #fff;
      border-radius: 12px;
      border: 1px solid #eee;
      padding: 25px 30px;
    }
    h2 {
      color: #5a3ef2;
      margin-top: 0;
      font-size: 22px;
    }
    .box {
      background: #f8f5ff;
      border-left: 4px solid #5a3ef2;
      padding: 16px 18px;
      border-radius: 8px;
      margin: 20px 0;
    }
    ul {
      padding-left: 18px;
    }
    li {
      margin: 6px 0;
    }
    .section-title {
      margin-top: 22px;
      font-size: 17px;
      color: #333;
    }
    .image-container {
      margin-top: 20px;
      text-align: center;
    }
    .preview-img {
      max-width: 100%;
      height: auto;
      border-radius: 10px;
      border: 1px solid #ddd;
      margin-top: 10px;
    }
    .btn {
      display: inline-block;
      margin: 10px 5px 0;
      padding: 10px 18px;
      font-size: 14px;
      text-decoration: none;
      border-radius: 6px;
      color: #fff;
    }
    .btn-view {
      background-color: #5a3ef2;
    }
    .btn-download {
      background-color: #28a745;
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      color: #888;
      font-size: 13px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <h2>Document Upload Issue Reported</h2>

    <p>Dear Team,</p>

    <p>
      A user has reported an issue while uploading onboarding documents.
      The issue and sender details are provided below for your reference.
    </p>

    <div class="box">
      <h3 style="margin:0 0 10px;">📌 Reported Issue</h3>
      <p><strong>${issue}</strong></p>
    </div>

    <h3 class="section-title">👤 Reported By (User Details)</h3>
    <ul>
      <li><b>Name:</b> ${userInfo.userName}</li>
      <li><b>Email:</b> ${userInfo.email}</li>
      <li><b>Contact Number:</b> ${userInfo.contactNumber}</li>
    </ul>

    <h3 class="section-title">🏥 Hospital Information</h3>
    <ul>
      <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
      <li><b>Description:</b> ${hospitalInfo.hospitalDesc}</li>
      <li><b>Address:</b> ${hospitalInfo.address}</li>
      <li><b>City:</b> ${hospitalInfo.city}</li>
      <li><b>State:</b> ${hospitalInfo.state}</li>
      <li><b>Country:</b> ${hospitalInfo.country}</li>
      <li><b>Email:</b> ${hospitalInfo.email}</li>
      <li><b>Contact Number:</b> ${hospitalInfo.contactNumber}</li>
      <li><b>Registration Number:</b> ${hospitalInfo.registrationNumber}</li>
    </ul>

    ${
      uploadedImageURL
        ? `
    <h3 class="section-title">📎 Uploaded Screenshot</h3>
    <div class="image-container">
      <img src="${uploadedImageURL}" alt="Uploaded Document Screenshot" class="preview-img" />

      <table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center" style="margin-top:15px;">
      <tr>
        <!-- View Button -->
        <td align="center" style="border-radius:8px;" bgcolor="#5a3ef2">
          <a href="${uploadedImageURL}" 
              target="_blank"
              style="
                display:inline-block;
                padding:12px 22px;
                font-size:14px;
                font-weight:600;
                color:#ffffff;
                text-decoration:none;
                border-radius:8px;
                font-family:Segoe UI,Roboto,Arial,sans-serif;
              ">
              🔍 View Full Image
          </a>
        </td>

        <!-- Spacer -->
        <td width="12"></td>

        <!-- Download Button -->
        <td align="center" style="border-radius:8px;" bgcolor="#28a745">
          <a href="${uploadedImageURL}" 
              download
              style="
                display:inline-block;
                padding:12px 22px;
                font-size:14px;
                font-weight:600;
                color:#ffffff;
                text-decoration:none;
                border-radius:8px;
                font-family:Segoe UI,Roboto,Arial,sans-serif;
              ">
              ⬇ Download Image
          </a>
        </td>
      </tr>
      </table>
    </div>
    `
        : ""
    }

    <p>
      Please review the issue and assist the user at the earliest.
      You may contact the user directly using the details provided above if required.
    </p>

    <p>
      Regards,<br />
      <strong>Nishwik Support System</strong>
    </p>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function onboardingTicketRaisedEmailForHospital(
  ticketNumber: string,
  issue: string,
  hospitalInfo: HospitalMasterDTO,
  userInfo: any,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Support Ticket Created</title>
  <style>
    body {
      margin: 0;
      padding: 0;
      background: #f4f6fb;
      font-family: "Segoe UI", Roboto, Arial, sans-serif;
      color: #2f2f2f;
    }

    .wrapper {
      max-width: 720px;
      margin: 30px auto;
      background: #ffffff;
      border-radius: 14px;
      overflow: hidden;
      border: 1px solid #e9e9ee;
    }

    .header {
      background: linear-gradient(135deg, #5a3ef2, #7b66ff);
      padding: 24px 30px;
      color: #ffffff;
    }

    .header h1 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
    }

    .content {
      padding: 28px 30px;
    }

    p {
      font-size: 14.5px;
      line-height: 1.7;
      margin: 10px 0;
    }

    .highlight {
      background: #f6f4ff;
      border-left: 4px solid #5a3ef2;
      padding: 16px 18px;
      border-radius: 10px;
      margin: 22px 0;
    }

    .ticket-badge {
      display: inline-block;
      background: #5a3ef2;
      color: #fff;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-top: 8px;
    }

    .section-title {
      margin-top: 28px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    ul {
      padding-left: 18px;
      margin: 8px 0;
    }

    li {
      font-size: 14px;
      margin: 6px 0;
    }

    .card {
      background: #fafbff;
      border: 1px solid #ececff;
      border-radius: 10px;
      padding: 16px 18px;
      margin-top: 12px;
    }

    .footer {
      text-align: center;
      font-size: 12.5px;
      color: #8a8a8a;
      padding: 20px;
      border-top: 1px solid #eee;
    }

    .signature {
      margin-top: 20px;
    }
  </style>
</head>

<body>
  <div class="wrapper">
    <div class="header">
      <h1>🎫 Support Ticket Created</h1>
    </div>

    <div class="content">
      <p>Dear <strong>${userInfo.userName}</strong>,</p>

      <p>
        Thank you for contacting Nishwik Support. Your request has been successfully registered.
        Our team will review the details and respond within
        <strong>24–48 hours</strong>.
      </p>

      <div class="highlight">
        <p><strong>Ticket Number</strong></p>
        <span class="ticket-badge">${ticketNumber}</span>

        <p style="margin-top:12px;"><strong>Issue Reported:</strong><br/>${issue}</p>
        <p><strong>Status:</strong> Open</p>
      </div>

      <div class="section-title">👤 Request Raised By</div>
      <div class="card">
        <ul>
          <li><b>Name:</b> ${userInfo.userName}</li>
          <li><b>Email:</b> ${userInfo.email}</li>
          <li><b>Contact Number:</b> ${userInfo.contactNumber}</li>
        </ul>
      </div>

      <div class="section-title">🏥 Hospital Information</div>
      <div class="card">
        <ul>
          <li><b>Hospital Name:</b> ${hospitalInfo.hospitalName}</li>
          <li><b>Description:</b> ${hospitalInfo.hospitalDesc}</li>
          <li><b>Address:</b> ${hospitalInfo.address}</li>
          <li><b>City:</b> ${hospitalInfo.city}</li>
          <li><b>State:</b> ${hospitalInfo.state}</li>
          <li><b>Country:</b> ${hospitalInfo.country}</li>
          <li><b>Email:</b> ${hospitalInfo.email}</li>
          <li><b>Contact Number:</b> ${hospitalInfo.contactNumber}</li>
          <li><b>Registration Number:</b> ${hospitalInfo.registrationNumber}</li>
        </ul>
      </div>

      <p>
        If additional details are required, our support team will contact you shortly.
        Please keep your ticket number for future communication.
      </p>

      <div class="signature">
        <p>
          Regards,<br />
          <strong>Nishwik Support Team</strong>
        </p>
      </div>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik. All rights reserved.
    </div>
  </div>
</body>
</html>
`;
}

export function onboardingSchoolDocumentUploadIssue(
  issue: string,
  schoolInfo: SchoolMasterDTO,
  userInfo: any,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>School Document Upload Issue</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: #ffffff;
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 30px auto;
      background: #fff;
      border-radius: 12px;
      border: 1px solid #eee;
      padding: 25px 30px;
    }
    h2 {
      color: #5a3ef2;
      margin-top: 0;
      font-size: 22px;
    }
    .box {
      background: #f8f5ff;
      border-left: 4px solid #5a3ef2;
      padding: 18px;
      border-radius: 8px;
      margin: 22px 0;
    }
    ul {
      padding-left: 18px;
    }
    li {
      margin: 6px 0;
    }
    .section-title {
      margin-top: 22px;
      font-size: 17px;
      color: #333;
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      color: #888;
      font-size: 13px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <h2>Document Upload Issue Reported</h2>

    <p>Dear Team,</p>

    <p>
      A school has reported an issue while uploading onboarding documents.
      Please find the issue and sender details below for your review.
    </p>

    <div class="box">
      <h3 style="margin:0 0 10px;">📌 Reported Issue</h3>
      <p><strong>${issue}</strong></p>
    </div>

    <h3 class="section-title">👤 Reported By (User Details)</h3>
    <ul>
      <li><b>Name:</b> ${userInfo.userName}</li>
      <li><b>Email:</b> ${userInfo.email}</li>
      <li><b>Contact Number:</b> ${userInfo.contactNumber}</li>
    </ul>

    <h3 class="section-title">🏫 School Information</h3>
    <ul>
      <li><b>School Name:</b> ${schoolInfo.schoolName}</li>
      <li><b>Description:</b> ${schoolInfo.description}</li>
      <li><b>Address:</b> ${schoolInfo.address}</li>
      <li><b>City:</b> ${schoolInfo.city}</li>
      <li><b>State:</b> ${schoolInfo.state}</li>
      <li><b>Pincode:</b> ${schoolInfo.pincode}</li>
      <li><b>Email:</b> ${schoolInfo.email}</li>
      <li><b>Phone Number:</b> ${schoolInfo.phoneNo}</li>
      <li><b>Affiliation Number:</b> ${schoolInfo.affiliationNumber}</li>
      <li><b>Board:</b> ${schoolInfo.boardName}</li>
      <li><b>Medium of Instruction:</b> ${schoolInfo.mediumOfInstruction}</li>
      <li><b>School Type:</b> ${schoolInfo.schoolType}</li>
    </ul>

    <p>
      Kindly review the issue and assist the school at the earliest.
      You may directly contact the user using the details provided above if needed.
    </p>

    <p>
      Regards,<br/>
      <strong>Nishwik Support System</strong>
    </p>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function PrescriptionEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  doctorInfo: HospitalUserAffiliationDTO,
  visitComplaints: VisitComplaintMasterDTO[],
  diagnosisList: PrescriptionDiagnosisMasterDTO[],
  medicationList: PrescriptionMedicationMasterDTO[],
  prescriptionInfo: PrescriptionMasterDTO,
  patientVisitList: PatientVisitMasterDTO,
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  const complaintRows = visitComplaints
    .map(
      (c) => `
<tr>
<td>${c.complaint}</td>
<td>${c.description ?? ""}</td>
<td>${c.sinceDuration ?? ""}</td>
<td>${c.summary ?? ""}</td>
</tr>
`,
    )
    .join("");

  const diagnosisRows = diagnosisList
    .map(
      (d) => `
<tr>
<td>${d.diagnosisName}</td>
<td>${d.findingNotes ?? ""}</td>
<td>${d.treatmentNotes ?? ""}</td>
</tr>
`,
    )
    .join("");

  const medicationRows = medicationList
    .map(
      (m) => `
<tr>
<td>${m.medicineName}</td>
<td>${m.strength ?? ""}</td>
<td>${m.doseMorning ?? ""}-${m.doseAfternoon ?? ""}-${m.doseEvening ?? ""}-${m.doseNight ?? ""}</td>
<td>${m.durationDays ?? ""}</td>
<td>${m.quantity ?? ""}</td>
</tr>
`,
    )
    .join("");

  return `
<!DOCTYPE html>
<html>
<head>

<style>

body{
  margin:0;
  padding:0;
  background:#f4f6fb;
  font-family:Arial, Helvetica, sans-serif;
}

.wrapper{
  max-width:760px;
  margin:auto;
  background:#ffffff;
  border:1px solid #e6e8f0;
  box-shadow:0 3px 10px rgba(0,0,0,0.08);
}

.header{
  background:linear-gradient(135deg,#032BAA,#011044);
  padding:20px;
  color:white;
}

.header-table{
  width:100%;
}

.logo{
  width:70px;
  height:70px;
  background:white;
  border-radius:6px;
  padding:5px;
}

.hospital-name{
  font-size:22px;
  font-weight:bold;
}

.hospital-address{
  font-size:10px;
  opacity:0.9;
}

.section{
  padding:20px 25px;
}

.section-title{
  font-size:16px;
  font-weight:bold;
  color:#032BAA;
  border-bottom:2px solid #eef2ff;
  padding-bottom:5px;
  margin-bottom:10px;
}

.info-table{
  width:100%;
  border-collapse:collapse;
  font-size:14px;
}

.info-table td{
  padding:8px 6px;
}

.label{
  font-weight:bold;
  color:#333;
}

.value{
  color:#555;
}

.data-table{
  width:100%;
  border-collapse:collapse;
  font-size:14px;
}

.data-table th{
  background:#eef2ff;
  border:1px solid #dfe3f3;
  padding:8px;
  text-align:left;
}

.data-table td{
  border:1px solid #e5e8f5;
  padding:8px;
}

.data-table tr:nth-child(even){
  background:#fafbff;
}

.remark-box{
  background:#f7f9ff;
  padding:12px;
  border-left:4px solid #032BAA;
  font-size:14px;
}

.signature{
  padding:20px;
  text-align:right;
}

.signature img{
  height:60px;
}

.footer{
  background:#f4f6fb;
  text-align:center;
  padding:15px;
  font-size:12px;
  color:#666;
}

</style>

</head>

<body>

<div class="wrapper">

<!-- HEADER -->

<div class="header">

<table class="header-table">

<tr>

<td width="90">
<img src="${hospitalInfo?.hospitalLogoURL ?? ""}" class="logo"/>
</td>

<td>
<div class="hospital-name">${hospitalInfo.hospitalName}</div>
<div class="hospital-address">
${hospitalInfo.address}, ${hospitalInfo.city}, ${hospitalInfo.state}
</div>
</td>

</tr>

</table>

</div>

<!-- PATIENT INFO -->

<div class="section">

<div class="section-title">Patient Information</div>

<table class="info-table">

<tr>
<td class="label">Patient Name</td>
<td class="value">${patientVisitList.firstName} ${patientVisitList.middleName} ${patientVisitList.lastName}</td>

<td class="label">Patient No</td>
<td class="value">${patientVisitList.patientNo}</td>
</tr>

<tr>
<td class="label">Gender</td>
<td class="value">${patientVisitList.gender}</td>

<td class="label">Age</td>
<td class="value">${patientVisitList.age}</td>
</tr>

<tr>
<td class="label">Visit Type</td>
<td class="value">${patientVisitList.visitType}</td>

<td class="label">Department</td>
<td class="value">${doctorInfo.department}</td>
</tr>

<tr>
<td class="label">Prescription No</td>
<td class="value">${prescriptionInfo.prescriptionNo}</td>

<td class="label">Doctor</td>
<td class="value">Dr. ${doctorInfo.firstName} ${doctorInfo.lastName}</td>
</tr>

<tr>
<td class="label">Date</td>
<td class="value">${formatDate(prescriptionInfo.createdOn.toString())}</td>
<td></td>
<td></td>
</tr>

</table>

</div>

<!-- COMPLAINTS -->

<div class="section">

<div class="section-title">Visit Complaints</div>

<table class="data-table">

<tr>
<th>Complaint</th>
<th>Description</th>
<th>Since</th>
<th>Summary</th>
</tr>

${complaintRows}

</table>

</div>

<!-- DIAGNOSIS -->

<div class="section">

<div class="section-title">Diagnosis</div>

<table class="data-table">

<tr>
<th>Diagnosis</th>
<th>Finding</th>
<th>Treatment</th>
</tr>

${diagnosisRows}

</table>

</div>

<!-- MEDICATION -->

<div class="section">

<div class="section-title">Medication</div>

<table class="data-table">

<tr>
<th>Medicine</th>
<th>Strength</th>
<th>Dose</th>
<th>Days</th>
<th>Qty</th>
</tr>

${medicationRows}

</table>

</div>

<!-- REMARK -->

<div class="section">

<div class="section-title">Doctor Remark</div>

<div class="remark-box">

${prescriptionInfo.visitNotes ?? ""}

</div>

</div>

<!-- SIGNATURE -->

<div class="signature">

<p><b>Doctor Signature</b></p>

<img src="${doctorInfo.signatureUrl ?? ""}"/>

<p><b>Dr. ${doctorInfo.firstName} ${doctorInfo.lastName}</b></p>
<p>Registration No: ${doctorInfo.registrationNumber}</p>

</div>

<!-- FOOTER -->

<div class="footer">

© ${new Date().getFullYear()} ${hospitalInfo.hospitalName}  
<br>
Digital Prescription Generated by <b>Nishwik Healthcare System</b>

</div>

</div>

</body>
</html>
`;
}

// export function dischargeSummaryEmailTemplate(
//   patient: TreatmentPlanMasterDTO,
//   hospitalInfo: HospitalMasterDTO,
//   hospitalId: number,
//   dischargeDate: Date
// ): string {

//   const admissionDate = patient.startDate ? new Date(patient.startDate) : null;

//   const stayDays = admissionDate
//     ? Math.max(1, Math.ceil(
//         (dischargeDate.getTime() - admissionDate.getTime()) / (1000 * 60 * 60 * 24)
//       ))
//     : null;

//   const firstName = patient.patientFirstName ?? "";
//   const lastName = patient.patientLastName ?? "";

//   const patientNo = patient.patientId ?? hospitalId;

//   const hospitalName = hospitalInfo?.hospitalName ?? "Hospital";
//   const hospitalCity = hospitalInfo?.city ?? "";
//   const hospitalPhone = hospitalInfo?.contactNumber ?? "";
//   const hospitalEmail = hospitalInfo?.email ?? "";
//   const hospitalLogo = hospitalInfo?.hospitalLogoURL ?? "";

//   const year = new Date().getFullYear();

//   return `
// <!DOCTYPE html>
// <html>
// <body style="margin:0;padding:0;background:#f4f6fb;font-family:Segoe UI,Arial">

// <table width="100%" cellpadding="0" cellspacing="0">
// <tr>
// <td align="center">

// <table width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 6px 20px rgba(0,0,0,0.08)">

// <!-- HEADER -->
// <tr>
// <td style="background:linear-gradient(135deg,#5b006b,#8e24aa);padding:30px;text-align:center;color:white">

//   ${
//     hospitalLogo
//       ? `<img src="${hospitalLogo}" style="width:60px;height:60px;border-radius:50%;object-fit:cover;margin-bottom:10px;border:2px solid #fff"/>`
//       : `<div style="width:60px;height:60px;border-radius:50%;background:rgba(255,255,255,0.2);display:inline-flex;align-items:center;justify-content:center;font-weight:bold">H+</div>`
//   }

//   <div style="font-size:20px;font-weight:600;margin-top:10px">${hospitalName}</div>
//   <div style="font-size:12px;opacity:0.8">${hospitalCity} • Healthcare</div>

// </td>
// </tr>

// <!-- SUCCESS -->
// <tr>
// <td style="padding:20px">

// <table width="100%" style="background:#ecfdf5;border:1px solid #a7f3d0;border-radius:10px;padding:12px">
// <tr>
// <td width="30">
// <div style="width:26px;height:26px;background:#10b981;border-radius:50%;text-align:center;color:white;font-weight:bold;line-height:26px">✓</div>
// </td>
// <td style="font-size:13px;color:#065f46">
// <b>Patient successfully discharged</b><br>
// ${firstName} ${lastName} was discharged on
// <b>${formatDate(dischargeDate)}</b>.
// </td>
// </tr>
// </table>

// </td>
// </tr>

// <!-- PATIENT DETAILS -->
// <tr>
// <td style="padding:0 20px">

// <div style="font-size:11px;color:#888;margin-bottom:8px">PATIENT DETAILS</div>

// <table width="100%" style="background:#f7f4fb;border-radius:10px;border:1px solid #e6def2">
// <tr><td style="padding:10px">
// <div style="font-size:11px;color:#777">Full Name</div>
// <div style="font-weight:600">${firstName} ${lastName}</div>
// </td></tr>
// </table>

// <br>

// <table width="100%" cellpadding="5">
// <tr>
// <td style="background:#f7f4fb;border-radius:10px;border:1px solid #e6def2">
// <div style="font-size:11px;color:#777">Patient ID</div>
// <div style="font-weight:600">${patientNo}</div>
// </td>

// <td style="background:#f7f4fb;border-radius:10px;border:1px solid #e6def2">
// <div style="font-size:11px;color:#777">Stay</div>
// <div style="font-weight:600">${stayDays ?? "-"} Days</div>
// </td>
// </tr>
// </table>

// </td>
// </tr>

// <!-- TIMELINE -->
// <tr>
// <td style="padding:20px">

// <table width="100%">
// <tr>

// <td align="center" style="background:#f7f4fb;border-radius:10px;padding:10px">
// <div style="font-size:11px;color:#777">Admission</div>
// <div style="font-weight:600">${formatDate(admissionDate)}</div>
// </td>

// <td align="center" style="font-size:18px;color:#bbb">→</td>

// <td align="center" style="background:#f7f4fb;border-radius:10px;padding:10px">
// <div style="font-size:11px;color:#777">Discharge</div>
// <div style="font-weight:600">${formatDate(dischargeDate)}</div>
// </td>

// </tr>
// </table>

// </td>
// </tr>

// <!-- NOTE -->
// <tr>
// <td style="padding:0 20px 20px">

// <table width="100%" style="background:#fff8e1;border:1px solid #fde68a;border-radius:10px">
// <tr>
// <td style="padding:12px;font-size:13px;color:#92400e">
// ⚠ Please follow all discharge instructions carefully and contact hospital if needed.
// </td>
// </tr>
// </table>

// </td>
// </tr>

// <!-- CONTACT -->
// <tr>
// <td style="padding:0 20px 20px">

// <table width="100%">
// <tr>

// <td style="background:#f7f4fb;border-radius:10px;border:1px solid #e6def2;padding:10px;font-size:12px">
// 📞 ${hospitalPhone}
// </td>

// <td style="background:#f7f4fb;border-radius:10px;border:1px solid #e6def2;padding:10px;font-size:12px">
// ✉ ${hospitalEmail}
// </td>

// </tr>
// </table>

// </td>
// </tr>

// <!-- FOOTER -->
// <tr>
// <td style="text-align:center;font-size:11px;color:#777;padding:15px;background:#fafafa">
// ${hospitalName} • ${hospitalCity}<br>
// © ${year} All rights reserved
// </td>
// </tr>

// </table>

// </td>
// </tr>
// </table>

// </body>
// </html>
// `;
// }

// function formatDate(date: Date | string | null | undefined): string {
//   if (!date) return "—";
//   const d = new Date(date);
//   if (isNaN(d.getTime())) return "—";
//   return d.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }

// export function dischargeSummaryEmailTemplate(
//   patient: TreatmentPlanMasterDTO,
//   hospitalInfo: HospitalMasterDTO,
//   hospitalId: number,
//   dischargeDate: Date,
// ): string {
//   const admissionDate = patient.startDate ? new Date(patient.startDate) : null;

//   const stayDays = admissionDate
//     ? Math.max(
//         1,
//         Math.ceil(
//           (dischargeDate.getTime() - admissionDate.getTime()) /
//             (1000 * 60 * 60 * 24),
//         ),
//       )
//     : null;

//   const firstName = patient.patientFirstName;
//   const lastName = patient.patientLastName;
//   const patientNo = patient.patientId;
//   const ward = patient.wardName;

//   const hospitalName = hospitalInfo?.hospitalName;
//   const hospitalCity = hospitalInfo?.city;
//   const hospitalPhone = hospitalInfo?.contactNumber;
//   const hospitalEmail = hospitalInfo?.email;
//   const hospitalLogo = hospitalInfo?.hospitalLogoURL;

//   const year = new Date().getFullYear();

//   // formatDate is in scope here — no ReferenceError
//   const admissionStr = formatDate(admissionDate);
//   const dischargeStr = formatDate(dischargeDate);

//   const logoBlock = hospitalLogo
//     ? `<img src="${hospitalLogo}" alt="${hospitalName}" style="width:56px;height:56px;border-radius:50%;object-fit:cover;border:2px solid rgba(255,255,255,0.5);margin-bottom:12px;display:block;margin-left:auto;margin-right:auto"/>`
//     : `<div style="width:56px;height:56px;border-radius:50%;background:rgba(255,255,255,0.18);border:2px solid rgba(255,255,255,0.4);display:inline-flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;color:#fff;margin-bottom:12px">H+</div>`;

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <meta name="viewport" content="width=device-width,initial-scale=1"/>
// <title>Discharge Summary — ${hospitalName}</title>
// </head>
// <body style="margin:0;padding:0;background:#f2edf8;font-family:'Segoe UI',Tahoma,Arial,sans-serif;-webkit-font-smoothing:antialiased">

// <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
// <tr><td align="center" style="padding:40px 16px">

//   <table width="600" cellpadding="0" cellspacing="0" role="presentation"
//          style="max-width:600px;width:100%;background:#ffffff;border-radius:20px;overflow:hidden;box-shadow:0 12px 48px rgba(80,0,100,0.13)">

//     <!-- ══ HEADER ══ -->
//     <tr>
//       <td style="background:linear-gradient(160deg,#3d0050 0%,#7b1fa2 60%,#a445c2 100%);padding:36px 32px 28px;text-align:center">
//         ${logoBlock}
//         <div style="color:#fff;font-size:22px;font-weight:700;letter-spacing:0.01em;margin-bottom:4px">${hospitalName}</div>
//         <div style="color:rgba(255,255,255,0.65);font-size:12px;letter-spacing:0.06em;text-transform:uppercase">${hospitalCity}${hospitalCity ? " &nbsp;·&nbsp; " : ""}Healthcare</div>
//       </td>
//     </tr>

//     <!-- ══ ACCENT LINE ══ -->
//     <tr>
//       <td style="height:4px;background:linear-gradient(90deg,#c026d3,#7c3aed,#c026d3)"></td>
//     </tr>

//     <!-- ══ BODY ══ -->
//     <tr>
//       <td style="padding:28px 28px 0">

//         <!-- Success badge -->
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation"
//                style="background:#f0fdf4;border:1px solid #86efac;border-radius:12px;margin-bottom:24px">
//           <tr>
//             <td width="46" style="padding:14px 0 14px 14px;vertical-align:top">
//               <div style="width:32px;height:32px;border-radius:50%;background:#22c55e;text-align:center;line-height:32px;font-size:15px;color:#fff;font-weight:700">✓</div>
//             </td>
//             <td style="padding:14px 14px 14px 10px">
//               <div style="font-size:14px;font-weight:700;color:#15803d;margin-bottom:3px">Patient successfully discharged</div>
//               <div style="font-size:13px;color:#6b7280;line-height:1.55">
//                 <span style="color:#374151;font-weight:500">${firstName} ${lastName}</span> was discharged on
//                 <span style="color:#374151;font-weight:600">${dischargeStr}</span>. We wish you a swift recovery.
//               </div>
//             </td>
//           </tr>
//         </table>

//         <!-- Section: Patient details -->
//         <div style="font-size:10.5px;font-weight:700;color:#a78bbd;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:10px">Patient Details</div>

//         <!-- Full name row -->
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation"
//                style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;margin-bottom:10px">
//           <tr>
//             <td style="padding:13px 16px">
//               <div style="font-size:10px;color:#a78bbd;font-weight:600;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:3px">Full Name</div>
//               <div style="font-size:15px;font-weight:700;color:#1f1235">${firstName} ${lastName}</div>
//             </td>
//           </tr>
//         </table>

//         <!-- Patient ID + Ward row -->
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:24px">
//           <tr>
//             <td width="48%" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:13px 16px">
//               <div style="font-size:10px;color:#a78bbd;font-weight:600;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:3px">Patient ID</div>
//               <div style="font-size:14px;font-weight:700;color:#1f1235">${patientNo}</div>
//             </td>
//             <td width="4%"></td>
//             <td width="48%" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:13px 16px">
//               <div style="font-size:10px;color:#a78bbd;font-weight:600;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:3px">Ward / Unit</div>
//               <div style="font-size:14px;font-weight:700;color:#1f1235">${ward}</div>
//             </td>
//           </tr>
//         </table>

//         <!-- Section: Stay summary -->
//         <div style="font-size:10.5px;font-weight:700;color:#a78bbd;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:10px">
//           Stay Summary &nbsp;
//           <span style="display:inline-block;background:#f3e8ff;color:#7c3aed;font-size:10px;font-weight:700;border-radius:99px;padding:2px 10px;vertical-align:middle">${stayDays ?? "—"} days</span>
//         </div>

//         <!-- Timeline -->
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:24px">
//           <tr>
//             <td align="center" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:14px 10px">
//               <div style="font-size:10px;color:#a78bbd;font-weight:600;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:4px">Admission</div>
//               <div style="font-size:14px;font-weight:700;color:#1f1235">${admissionStr}</div>
//             </td>
//             <td align="center" width="44"
//                 style="font-size:22px;color:#c4b5d6;font-weight:300;letter-spacing:-2px;text-align:center">&#8594;</td>
//             <td align="center" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:14px 10px">
//               <div style="font-size:10px;color:#a78bbd;font-weight:600;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:4px">Discharge</div>
//               <div style="font-size:14px;font-weight:700;color:#7c3aed">${dischargeStr}</div>
//             </td>
//           </tr>
//         </table>

//         <!-- Instructions note -->
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation"
//                style="background:#fffbeb;border:1px solid #fde68a;border-radius:12px;margin-bottom:24px">
//           <tr>
//             <td style="padding:14px 16px;font-size:13px;color:#92400e;line-height:1.6">
//               &#9888;&#65039; Please follow all discharge instructions and prescribed medications carefully.
//               Contact the hospital immediately if you experience worsening symptoms.
//             </td>
//           </tr>
//         </table>

//         <!-- Contact row -->
//         <div style="font-size:10.5px;font-weight:700;color:#a78bbd;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:10px">Emergency Contact</div>
//         <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:28px">
//           <tr>
//             <td width="48%" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:12px 14px;font-size:12px;color:#4b5563">
//               &#128222;&nbsp; <span style="font-weight:600;color:#374151">${hospitalPhone}</span>
//             </td>
//             <td width="4%"></td>
//             <td width="48%" style="background:#faf7ff;border:1px solid #ede8f7;border-radius:12px;padding:12px 14px;font-size:12px;color:#4b5563;word-break:break-all">
//               &#9993;&nbsp; <span style="font-weight:600;color:#374151">${hospitalEmail}</span>
//             </td>
//           </tr>
//         </table>

//       </td>
//     </tr>

//     <!-- ══ FOOTER ══ -->
//     <tr>
//       <td style="background:#f9f6ff;border-top:1px solid #ede8f7;padding:16px 28px;text-align:center">
//         <div style="font-size:12px;color:#6b7280;margin-bottom:3px">
//           <span style="font-weight:600;color:#5b21b6">${hospitalName}</span>${hospitalCity ? ` &nbsp;·&nbsp; ${hospitalCity}` : ""}
//         </div>
//         <div style="font-size:11px;color:#9ca3af">© ${year} All rights reserved</div>
//       </td>
//     </tr>

//   </table>

// </td></tr>
// </table>

// </body>
// </html>`;
// }

function formatDate(date: Date | null | string | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function fmt(n: number | null | undefined): string {
  if (n == null || isNaN(Number(n))) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN");
}

function safeText(value: any, fallback = "—"): string {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
}

function safeNum(value: any, fallback = 0): number {
  const num = Number(value);
  return isNaN(num) ? fallback : num;
}

function escapeHtml(value: any): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export interface DischargeSummaryEmailData {
  patient: TreatmentPlanMasterDTO;
  hospitalInfo: HospitalMasterDTO;
  hospitalId: number;
  dischargeDate: Date;
  hospitalServiceDetails: HospitalInvoiceDetailDTO[];
  treatmentServiceDetails: HospitalInvoiceDetailDTO[];
  medicineDetails: HospitalInvoiceDetailDTO[];
  loadMedicine: TreatmentMedicineMasterDTO[];
  services: TreatmentPlanDetailDTO[];
  patientAllocatedBedInfo: HospitalBedMasterDTO | null;
  bedOccupancyDays: number;
  totalBedCharge: number;
  doctorName?: string;
  loadOrders: TreatmentOrderMasterDTO[];
  UHID: any;
  logoBase64?: string;
}



export function dischargeSummaryEmailTemplate(
  data: DischargeSummaryEmailData,
): string {
  const {
    patient,
    hospitalInfo,
    dischargeDate,
    hospitalServiceDetails,
    treatmentServiceDetails,
    medicineDetails,
    loadMedicine,
    services,
    patientAllocatedBedInfo,
    bedOccupancyDays,
    totalBedCharge,
    doctorName,
    loadOrders,
  } = data;

  const admissionDate = patient?.startDate ? new Date(patient.startDate) : null;
  const stayDays = admissionDate
    ? Math.max(
        1,
        Math.ceil(
          (new Date(dischargeDate).getTime() - admissionDate.getTime()) /
            (1000 * 60 * 60 * 24),
        ),
      )
    : null;

  const firstName = safeText(patient?.patientFirstName, "");
  const lastName = safeText(patient?.patientLastName, "");
  const fullName = `${firstName} ${lastName}`.trim() || "—";
  const UHID = safeText(data.UHID, "—");
  const ward = safeText(patient?.wardName);
  const hospitalName = safeText(hospitalInfo?.hospitalName, "Hospital");
  const hospitalCity = safeText(hospitalInfo?.city, "");
  const hospitalPhone = safeText(hospitalInfo?.contactNumber);
  const hospitalEmail = safeText(hospitalInfo?.email);
  const hospitalLogo = hospitalInfo?.hospitalLogoURL;
  const year = new Date().getFullYear();

  const admissionStr = formatDate(admissionDate);
  const dischargeStr = formatDate(dischargeDate);

  const totalHospSvc = (hospitalServiceDetails || []).reduce(
    (s, r: any) => s + safeNum(r?.amount, 0),
    0,
  );
  const totalTreatSvc = (treatmentServiceDetails || []).reduce(
    (s, r: any) => s + safeNum(r?.amount, 0),
    0,
  );
  const totalMed = (medicineDetails || []).reduce(
    (s, r: any) => s + safeNum(r?.amount, 0),
    0,
  );
  const grandTotal =
    totalHospSvc + totalTreatSvc + totalMed + safeNum(totalBedCharge, 0);

const defaultLogo = "https://dev.apig.nishwik.com/Uploads/f29fdc6e-1412-45d1-b2a0-7aa967cba184.jpg";

const finalLogo =
  data.logoBase64 && data.logoBase64.trim() !== ""
    ? data.logoBase64
    : hospitalLogo && hospitalLogo.trim() !== "" && hospitalLogo !== "—"
    ? hospitalLogo
    : defaultLogo;

  const getAmountCell = (amount: any) => `
    <td style="padding:10px 12px;font-size:12px;color:#111827;border-bottom:1px solid #f3f4f6;text-align:right;font-weight:700">
      ${fmt(safeNum(amount, 0))}
    </td>`;

  const getMutedCell = (
    value: any,
    align: "left" | "center" | "right" = "left",
  ) => `
    <td style="padding:10px 12px;font-size:12px;color:#6b7280;border-bottom:1px solid #f3f4f6;text-align:${align}">
      ${escapeHtml(safeText(value))}
    </td>`;

  const getMoneyCell = (
    value: any,
    align: "left" | "center" | "right" = "right",
    color = "#111827",
    bold = false,
  ) => `
    <td style="padding:10px 12px;font-size:12px;color:${color};border-bottom:1px solid #f3f4f6;text-align:${align};font-weight:${bold ? "700" : "500"}">
      ${fmt(safeNum(value, 0))}
    </td>`;

  const bedChargesRows = patientAllocatedBedInfo
    ? `
      <tr>
        ${getMutedCell(ward)}
        ${getMutedCell((patientAllocatedBedInfo as any)?.roomNumber ?? (patientAllocatedBedInfo as any)?.roomNo ?? "—")}
        ${getMutedCell((patientAllocatedBedInfo as any)?.bedNumber ?? "—")}
        ${getMutedCell((patientAllocatedBedInfo as any)?.bedType ?? "—")}
        ${getMutedCell(admissionStr)}
        ${getMutedCell(dischargeStr)}
        ${getMoneyCell((patientAllocatedBedInfo as any)?.totalCharge ?? 0)}
        ${getAmountCell(totalBedCharge)}
      </tr>
    `
    : `
      <tr>
        <td colspan="8" style="padding:14px;text-align:center;font-size:12px;color:#9ca3af">
          No bed stay details available
        </td>
      </tr>
    `;

  const hospitalServiceRows =
    hospitalServiceDetails?.length > 0
      ? hospitalServiceDetails
          .map((s: any) => {
            const rowDate =
              s?.serviceDate ||
              s?.date ||
              s?.createdOn ||
              s?.invoiceDate ||
              dischargeDate;

            return `
              <tr>
                ${getMutedCell(formatDate(rowDate))}
                ${getMutedCell(s?.serviceName ?? s?.itemName ?? "—")}
                ${getMoneyCell(s?.baseAmount ?? s?.base ?? s?.grossAmount ?? s?.amount ?? 0)}
                ${getMoneyCell(s?.discountAmount ?? s?.discount ?? 0, "right", safeNum(s?.discountAmount ?? s?.discount, 0) > 0 ? "#dc2626" : "#f97316", true)}
                ${getMoneyCell(s?.taxAmount ?? s?.tax ?? 0, "right", safeNum(s?.taxAmount ?? s?.tax, 0) > 0 ? "#f97316" : "#f97316", true)}
                ${getAmountCell(s?.amount ?? 0)}
              </tr>
            `;
          })
          .join("")
      : `
        <tr>
          <td colspan="6" style="padding:14px;text-align:center;font-size:12px;color:#9ca3af">
            No hospital services recorded
          </td>
        </tr>
      `;

  const treatmentServiceRows =
    treatmentServiceDetails?.length > 0
      ? treatmentServiceDetails
          .map((s: any) => {
            const rowDate =
              s?.serviceDate ||
              s?.date ||
              s?.createdOn ||
              s?.invoiceDate ||
              dischargeDate;

            return `
              <tr>
                ${getMutedCell(formatDate(rowDate))}
                ${getMutedCell(s?.serviceName ?? s?.staffName ?? s?.procedureName ?? s?.treatmentName ?? "—")}
                ${getMoneyCell(s?.baseAmount ?? s?.base ?? s?.grossAmount ?? s?.amount ?? 0)}
                ${getMoneyCell(s?.discountAmount ?? s?.discount ?? 0, "right", safeNum(s?.discountAmount ?? s?.discount, 0) > 0 ? "#dc2626" : "#f97316", true)}
                ${getMoneyCell(s?.taxAmount ?? s?.tax ?? 0, "right", safeNum(s?.taxAmount ?? s?.tax, 0) > 0 ? "#f97316" : "#f97316", true)}
                ${getAmountCell(s?.amount ?? 0)}
              </tr>
            `;
          })
          .join("")
      : `
        <tr>
          <td colspan="6" style="padding:14px;text-align:center;font-size:12px;color:#9ca3af">
            No treatment procedures recorded
          </td>
        </tr>
      `;

  const medicineBillRows =
    medicineDetails?.length > 0
      ? medicineDetails
          .map((m: any) => {
            const rowDate =
              m?.serviceDate ||
              m?.date ||
              m?.createdOn ||
              m?.invoiceDate ||
              dischargeDate;

            return `
              <tr>
                ${getMutedCell(formatDate(rowDate))}
                ${getMutedCell(m?.serviceName ?? m?.itemName ?? m?.medicineName ?? "—")}
                ${getMoneyCell(m?.baseAmount ?? m?.base ?? m?.grossAmount ?? m?.amount ?? 0)}
                ${getMoneyCell(m?.discountAmount ?? m?.discount ?? 0, "right", safeNum(m?.discountAmount ?? m?.discount, 0) > 0 ? "#dc2626" : "#f97316", true)}
                ${getMoneyCell(m?.taxAmount ?? m?.tax ?? 0, "right", safeNum(m?.taxAmount ?? m?.tax, 0) > 0 ? "#f97316" : "#f97316", true)}
                ${getAmountCell(m?.amount ?? 0)}
              </tr>
            `;
          })
          .join("")
      : `
        <tr>
          <td colspan="6" style="padding:14px;text-align:center;font-size:12px;color:#9ca3af">
            No medicine charges recorded
          </td>
        </tr>
      `;

  const treatmentOrderRows =
    loadOrders?.length > 0
      ? loadOrders
          .map((o: any) => {
            const orderDate =
              o?.orderDate ||
              o?.date ||
              o?.createdOn ||
              o?.treatmentDate ||
              dischargeDate;

            const orderName =
              o?.orderCategory ||
              o?.treatmentOrder ||
              o?.serviceName ||
              o?.orderType ||
              o?.instruction ||
              "—";

            const orderNotes =
              o?.orderDescription ||
              o?.remarks ||
              o?.description ||
              o?.comment ||
              "—";

            const badgeBg =
              status.toLowerCase() === "completed"
                ? "#dcfce7"
                : status.toLowerCase() === "pending"
                  ? "#fef3c7"
                  : "#e5e7eb";

            const badgeColor =
              status.toLowerCase() === "completed"
                ? "#15803d"
                : status.toLowerCase() === "pending"
                  ? "#92400e"
                  : "#4b5563";

            return `
              <tr>
                ${getMutedCell(formatDate(orderDate))}
                ${getMutedCell(orderName)}
                ${getMutedCell(orderNotes)}
                <td style="padding:10px 12px;font-size:12px;border-bottom:1px solid #f3f4f6;text-align:center">
                  <span style="background:${badgeBg};color:${badgeColor};padding:3px 10px;border-radius:999px;font-size:11px;font-weight:700">
                    ${escapeHtml(status)}
                  </span>
                </td>
              </tr>
            `;
          })
          .join("")
      : `
        <tr>
          <td colspan="4" style="padding:14px;text-align:center;font-size:12px;color:#9ca3af">
            No treatment orders recorded
          </td>
        </tr>
      `;

  const medicineRows =
    loadMedicine?.length > 0
      ? loadMedicine
          .map((m: any) => {
            const medicineType =
              Number(m?.isInternal) === 1 ? "Internal" : "External";

            const medicineTypeBg =
              Number(m?.isInternal) === 1 ? "#dcfce7" : "#fee2e2";

            const medicineTypeColor =
              Number(m?.isInternal) === 1 ? "#15803d" : "#dc2626";

            const medicineStatus = safeText(m?.status, "—");

            return `
            <tr>
              <td style="padding:9px 12px;font-size:12px;color:#374151;border-bottom:1px solid #f3f4f6">
                ${escapeHtml(safeText(m?.medicine))}
              </td>

              <td style="padding:9px 12px;font-size:12px;color:#6b7280;border-bottom:1px solid #f3f4f6;text-align:center">
                ${escapeHtml(
                  `${safeText(m?.morning, "0")}-${safeText(m?.afternoon, "0")}-${safeText(
                    m?.evening,
                    "0",
                  )}-${safeText(m?.night, "0")}`,
                )}
              </td>

              <td style="padding:9px 12px;font-size:12px;color:#6b7280;border-bottom:1px solid #f3f4f6;text-align:center">
                ${escapeHtml(safeText(m?.quantity))}
              </td>

              <td style="padding:9px 12px;font-size:12px;color:#6b7280;border-bottom:1px solid #f3f4f6;text-align:center">
                ${escapeHtml(safeText(m?.days))}
              </td>

              <td style="padding:9px 12px;font-size:12px;color:#111827;border-bottom:1px solid #f3f4f6;text-align:right;font-weight:700">
                ${fmt(safeNum(m?.price, 0))}
              </td>

              <td style="padding:9px 12px;border-bottom:1px solid #f3f4f6;text-align:center">
                <span style="display:inline-block;padding:4px 10px;border-radius:999px;background:${medicineTypeBg};color:${medicineTypeColor};font-size:11px;font-weight:700">
                  ${medicineType}
                </span>
              </td>
            </tr>
          `;
          })
          .join("")
      : `<tr><td colspan="8" style="padding:14px;text-align:center;font-size:12.5px;color:#9ca3af">No prescriptions recorded</td></tr>`;

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>Discharge Summary — ${escapeHtml(hospitalName)}</title>
</head>
<body style="margin:0;padding:0;background:#eef2f7;font-family:'Segoe UI',Tahoma,Arial,sans-serif;-webkit-font-smoothing:antialiased">

<table width="100%" cellpadding="0" cellspacing="0" role="presentation">
<tr><td align="center" style="padding:36px 12px">

  <table width="760" cellpadding="0" cellspacing="0" role="presentation"
         style="max-width:760px;width:100%;border-radius:20px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.14)">

    <tr>
      <td style="background:linear-gradient(145deg,#0f172a 0%,#1e3a5f 50%,#0e4d7b 100%);padding:40px 36px 32px;text-align:center">
        <div style="color:#fff;font-size:24px;font-weight:800;letter-spacing:-0.3px;margin-bottom:4px">${escapeHtml(
          hospitalName,
        )}</div>
        <div style="color:rgba(255,255,255,0.55);font-size:11.5px;letter-spacing:0.12em;text-transform:uppercase;margin-bottom:18px">
          ${hospitalCity ? escapeHtml(hospitalCity) + " &nbsp;·&nbsp; " : ""}Healthcare Excellence
        </div>
        <div style="display:inline-block;background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.25);border-radius:99px;padding:6px 20px;font-size:12px;color:rgba(255,255,255,0.9);font-weight:600;letter-spacing:0.05em;text-transform:uppercase">
          ✦ &nbsp;Discharge Summary&nbsp; ✦
        </div>
      </td>
    </tr>

    <tr><td style="height:4px;background:linear-gradient(90deg,#3b82f6,#06b6d4,#3b82f6)"></td></tr>

    <tr>
      <td style="background:#ffffff;padding:32px 32px 0">

<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:10px">
  <tr>
    <td style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:16px 18px;">
      
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          
          <!-- LEFT: Patient Name -->
          <td style="vertical-align:middle;">
            <div style="font-size:10px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;margin-bottom:6px">
              Patient Name
            </div>
            <div style="font-size:18px;font-weight:800;color:#0f172a;line-height:1.3">
              ${escapeHtml(fullName)}
            </div>
          </td>

          <!-- RIGHT: UHID -->
          <td align="right" style="vertical-align:middle;min-width:140px;">
            <div style="font-size:10px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;margin-bottom:6px">
              UHID
            </div>

            <div style="display:inline-block;
                        padding:6px 14px;
                        border-radius:8px;
                        background:#eff6ff;
                        color:#2563eb;
                        font-size:14px;
                        font-weight:800;
                        letter-spacing:0.05em;">
              ${escapeHtml(UHID || "N/A")}
            </div>
          </td>

        </tr>
      </table>

    </td>
  </tr>
</table>
        <div style="font-size:10px;font-weight:800;color:#64748b;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:6px;border-bottom:2px solid #e2e8f0;margin-top:28px">
           01 &nbsp; Hospital Stay Summary
        </div>

        <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:10px">
          <tr>
            <td align="center" style="background:linear-gradient(135deg,#eff6ff,#dbeafe);border:1px solid #bfdbfe;border-radius:12px;padding:16px 10px">
              <div style="font-size:9.5px;color:#3b82f6;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:5px">📅 Admission Date</div>
              <div style="font-size:15px;font-weight:800;color:#1e40af">${escapeHtml(admissionStr)}</div>
            </td>
            <td align="center" width="50" style="font-size:20px;color:#94a3b8;text-align:center">→</td>
            <td align="center" style="background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:1px solid #86efac;border-radius:12px;padding:16px 10px">
              <div style="font-size:9.5px;color:#22c55e;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:5px">🚪 Discharge Date</div>
              <div style="font-size:15px;font-weight:800;color:#166534">${escapeHtml(dischargeStr)}</div>
            </td>
            <td align="center" width="50" style="font-size:20px;color:#94a3b8;text-align:center">=</td>
            <td align="center" style="background:linear-gradient(135deg,#faf5ff,#ede9fe);border:1px solid #c4b5fd;border-radius:12px;padding:16px 10px">
              <div style="font-size:9.5px;color:#7c3aed;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:5px">🌙 Total Stay</div>
              <div style="font-size:15px;font-weight:800;color:#5b21b6">${stayDays ?? "—"} Days</div>
            </td>
          </tr>
        </table>

        <div style="margin-top:18px;margin-bottom:10px;background:#ffffff;border:1px solid #eadcf8;border-radius:14px;overflow:hidden">
          <div style="padding:14px 16px;border-bottom:1px solid #f3e8ff;background:#fcfaff">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td style="font-size:13px;font-weight:700;color:#111827">Hospital Stay &amp; Bed Charges <span style="font-size:12px;color:#6b7280;font-weight:500">${safeNum(
                  bedOccupancyDays,
                  0,
                )} days</span></td>
                <td align="right">
                  <span style="display:inline-block;padding:6px 12px;border-radius:999px;background:#f3e8ff;color:#7c3aed;font-size:12px;font-weight:700">
                    Total ${fmt(totalBedCharge)}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse">
            <tr style="background:#faf7fd">
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Ward</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Room</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Bed</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Type</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">From</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">To</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Charge/Day</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Total</th>
            </tr>
            ${bedChargesRows}
            <tr style="background:#fcfaff">
              <td colspan="7" style="padding:10px 12px;text-align:right;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase">Total Bed Charges</td>
              <td style="padding:10px 12px;text-align:right;font-size:13px;font-weight:800;color:#7c3aed">${fmt(
                totalBedCharge,
              )}</td>
            </tr>
          </table>
        </div>

        <div style="font-size:10px;font-weight:800;color:#64748b;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:6px;border-bottom:2px solid #e2e8f0;margin-top:28px">
         02 &nbsp; Treatment Orders
        </div>

        <table width="100%" cellpadding="0" cellspacing="0" role="presentation"
               style="border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:20px">
          <tr style="background:#f1f5f9">
            <th style="padding:10px 14px;text-align:left;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Date</th>
            <th style="padding:10px 14px;text-align:left;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Treatment Order</th>
            <th style="padding:10px 14px;text-align:left;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Notes</th>
          </tr>
          ${treatmentOrderRows}
        </table>

        <div style="font-size:10px;font-weight:800;color:#64748b;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:6px;border-bottom:2px solid #e2e8f0;margin-top:28px">
          03 &nbsp; Prescribed Medications
        </div>

<table width="100%" cellpadding="0" cellspacing="0" role="presentation"
       style="border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:10px">
  <tr style="background:#f1f5f9">
    <th style="padding:10px 12px;text-align:left;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Medicine</th>
    <th style="padding:10px 12px;text-align:center;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Dosage</th>
    <th style="padding:10px 12px;text-align:center;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Qty</th>
    <th style="padding:10px 12px;text-align:center;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Days</th>
    <th style="padding:10px 12px;text-align:right;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Price</th>
    <th style="padding:10px 12px;text-align:center;font-size:10.5px;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:0.08em">Type</th>
  </tr>
  ${medicineRows}
</table>

        <div style="font-size:10px;font-weight:800;color:#64748b;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:6px;border-bottom:2px solid #e2e8f0;margin-top:28px">
          04 &nbsp; Billing Breakdown
        </div>

        <div style="margin-bottom:16px;background:#ffffff;border:1px solid #eadcf8;border-radius:14px;overflow:hidden">
          <div style="padding:14px 16px;border-bottom:1px solid #f3e8ff;background:#fcfaff">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td style="font-size:13px;font-weight:700;color:#111827">Hospital Services <span style="font-size:12px;color:#6b7280;font-weight:500">General</span></td>
                <td align="right">
                  <span style="display:inline-block;padding:6px 12px;border-radius:999px;background:#eff6ff;color:#2563eb;font-size:12px;font-weight:700">
                    Total ${fmt(totalHospSvc)}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
            <tr style="background:#faf7fd">
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Date</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Service</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Base</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Discount</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Tax</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Amount</th>
            </tr>
            ${hospitalServiceRows}
            <tr style="background:#fcfaff">
              <td colspan="5" style="padding:10px 12px;text-align:right;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase">Services Subtotal</td>
              <td style="padding:10px 12px;text-align:right;font-size:13px;font-weight:800;color:#2563eb">${fmt(
                totalHospSvc,
              )}</td>
            </tr>
          </table>
        </div>

        <div style="margin-bottom:16px;background:#ffffff;border:1px solid #eadcf8;border-radius:14px;overflow:hidden">
          <div style="padding:14px 16px;border-bottom:1px solid #f3e8ff;background:#fcfaff">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td style="font-size:13px;font-weight:700;color:#111827">Treatment &amp; Procedures <span style="display:inline-block;margin-left:6px;padding:3px 8px;border-radius:999px;background:#ede9fe;color:#7c3aed;font-size:10px;font-weight:700;vertical-align:middle">CLINICAL</span></td>
                <td align="right">
                  <span style="display:inline-block;padding:6px 12px;border-radius:999px;background:#f5f3ff;color:#7c3aed;font-size:12px;font-weight:700">
                    Total ${fmt(totalTreatSvc)}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
            <tr style="background:#faf7fd">
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Date</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Procedure / Treatment</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Base</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Discount</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Tax</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Amount</th>
            </tr>
            ${treatmentServiceRows}
            <tr style="background:#fcfaff">
              <td colspan="5" style="padding:10px 12px;text-align:right;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase">Treatment Subtotal</td>
              <td style="padding:10px 12px;text-align:right;font-size:13px;font-weight:800;color:#7c3aed">${fmt(
                totalTreatSvc,
              )}</td>
            </tr>
          </table>
        </div>

        <div style="margin-bottom:16px;background:#ffffff;border:1px solid #eadcf8;border-radius:14px;overflow:hidden">
          <div style="padding:14px 16px;border-bottom:1px solid #f3e8ff;background:#fcfaff">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td style="font-size:13px;font-weight:700;color:#111827">Medicines &amp; Consumables</td>
                <td align="right">
                  <span style="display:inline-block;padding:6px 12px;border-radius:999px;background:#fdf2f8;color:#db2777;font-size:12px;font-weight:700">
                    Total ${fmt(totalMed)}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
            <tr style="background:#faf7fd">
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Date</th>
              <th style="padding:10px 12px;text-align:left;font-size:10px;color:#6b7280;text-transform:uppercase">Medicine / Item</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Base</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Discount</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Tax</th>
              <th style="padding:10px 12px;text-align:right;font-size:10px;color:#6b7280;text-transform:uppercase">Amount</th>
            </tr>
            ${medicineBillRows}
            <tr style="background:#fcfaff">
              <td colspan="5" style="padding:10px 12px;text-align:right;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase">Medicine Subtotal</td>
              <td style="padding:10px 12px;text-align:right;font-size:13px;font-weight:800;color:#db2777">${fmt(
                totalMed,
              )}</td>
            </tr>
          </table>
        </div>

        <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:28px">
          <tr>
            <td style="background:linear-gradient(135deg,#0f172a 0%,#1e3a5f 100%);border-radius:14px;padding:20px 22px">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td style="color:rgba(255,255,255,0.6);font-size:11.5px">🛏️ Bed &amp; Stay</td>
                  <td align="right" style="color:rgba(255,255,255,0.9);font-size:13px;font-weight:700">${fmt(
                    totalBedCharge,
                  )}</td>
                </tr>
                <tr>
                  <td style="color:rgba(255,255,255,0.6);font-size:11.5px;padding-top:5px">🏥 Hospital Services</td>
                  <td align="right" style="color:rgba(255,255,255,0.9);font-size:13px;font-weight:700;padding-top:5px">${fmt(
                    totalHospSvc,
                  )}</td>
                </tr>
                <tr>
                  <td style="color:rgba(255,255,255,0.6);font-size:11.5px;padding-top:5px">🩺 Treatment &amp; Procedures</td>
                  <td align="right" style="color:rgba(255,255,255,0.9);font-size:13px;font-weight:700;padding-top:5px">${fmt(
                    totalTreatSvc,
                  )}</td>
                </tr>
                <tr>
                  <td style="color:rgba(255,255,255,0.6);font-size:11.5px;padding-top:5px">💊 Medicines</td>
                  <td align="right" style="color:rgba(255,255,255,0.9);font-size:13px;font-weight:700;padding-top:5px">${fmt(
                    totalMed,
                  )}</td>
                </tr>
                <tr>
                  <td colspan="2" style="padding-top:14px;border-top:1px solid rgba(255,255,255,0.15)"></td>
                </tr>
                <tr>
                  <td style="color:#fff;font-size:15px;font-weight:800;padding-top:10px">Grand Total</td>
                  <td align="right" style="padding-top:10px">
                    <span style="background:linear-gradient(135deg,#3b82f6,#06b6d4);color:#fff;font-size:18px;font-weight:900;padding:4px 16px;border-radius:99px">${fmt(
                      grandTotal,
                    )}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <table width="100%" cellpadding="0" cellspacing="0" role="presentation"
               style="background:linear-gradient(135deg,#fffbeb,#fef3c7);border:1px solid #fcd34d;border-radius:14px;margin-bottom:28px">
          <tr>
            <td style="padding:16px 18px">
              <div style="font-size:13px;font-weight:800;color:#92400e;margin-bottom:8px">⚠️ Post-Discharge Instructions</div>
              <ul style="margin:0;padding-left:18px;color:#78350f;font-size:12.5px;line-height:1.9">
                <li>Follow all prescribed medications strictly as directed by your doctor.</li>
                <li>Maintain a nutritious diet and adequate rest during recovery.</li>
                <li>Avoid strenuous physical activity unless cleared by your physician.</li>
                <li>Contact the hospital immediately if symptoms worsen or new symptoms arise.</li>
                <li>Keep all discharge documents safely for future medical reference.</li>
              </ul>
            </td>
          </tr>
        </table>

        <div style="font-size:10px;font-weight:800;color:#64748b;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:12px;padding-bottom:6px;border-bottom:2px solid #e2e8f0">
          Emergency Contact
        </div>
        <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="margin-bottom:32px">
          <tr>
            <td width="48%" style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:13px 15px">
              <div style="font-size:9.5px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:4px">📞 Phone</div>
              <div style="font-size:14px;font-weight:700;color:#0f172a">${escapeHtml(
                hospitalPhone,
              )}</div>
            </td>
            <td width="4%"></td>
            <td width="48%" style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:13px 15px;word-break:break-all">
              <div style="font-size:9.5px;color:#94a3b8;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:4px">✉️ Email</div>
              <div style="font-size:13px;font-weight:700;color:#0f172a">${escapeHtml(
                hospitalEmail,
              )}</div>
            </td>
          </tr>
        </table>

      </td>
    </tr>

    <tr>
      <td style="background:#0f172a;padding:22px 32px;text-align:center">
        <div style="font-size:13px;font-weight:700;color:#fff;margin-bottom:4px">${escapeHtml(
          hospitalName,
        )}</div>
        <div style="font-size:11px;color:rgba(255,255,255,0.4);margin-bottom:10px">${
          hospitalCity ? escapeHtml(hospitalCity) + " &nbsp;·&nbsp; " : ""
        }Healthcare Excellence</div>
        <div style="height:1px;background:rgba(255,255,255,0.1);margin-bottom:10px"></div>
        <div style="font-size:10.5px;color:rgba(255,255,255,0.35)">
          This is an automatically generated discharge summary. &nbsp;·&nbsp; © ${year} ${escapeHtml(
            hospitalName,
          )}. All rights reserved.
        </div>
      </td>
    </tr>

  </table>

</td></tr>
</table>

</body>
</html>`;
}

export function softwareSupportTicketEmail(
  issue: string,
  clientName: string,
  userInfo: any,
  uploadedImageURL: string | null,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Software Support Ticket Raised</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: #f4f6f9;
      margin: 0;
      padding: 0;
      color: #333;
    }
    .email-container {
      max-width: 720px;
      margin: 30px auto;
      background: #ffffff;
      border-radius: 14px;
      border: 1px solid #e5e7eb;
      padding: 30px;
    }
    .header {
      text-align: center;
      margin-bottom: 25px;
    }
    .badge {
      display: inline-block;
      padding: 6px 14px;
      font-size: 13px;
      font-weight: 600;
      border-radius: 20px;
      background: #e9f2ff;
      color: #0d6efd;
      margin-bottom: 10px;
    }
    h2 {
      margin: 8px 0 0 0;
      font-size: 22px;
      color: #0d6efd;
    }
    .issue-box {
      background: #f1f5ff;
      border-left: 5px solid #0d6efd;
      padding: 18px;
      border-radius: 10px;
      margin: 25px 0;
    }
    .section-title {
      margin-top: 25px;
      font-size: 15px;
      font-weight: 600;
      color: #111827;
      border-bottom: 1px solid #e5e7eb;
      padding-bottom: 6px;
    }
    ul {
      padding-left: 18px;
      margin-top: 10px;
    }
    li {
      margin: 6px 0;
    }
    .preview-img {
      max-width: 100%;
      height: auto;
      border-radius: 10px;
      border: 1px solid #ddd;
      margin-top: 15px;
    }
    .footer {
      margin-top: 40px;
      text-align: center;
      font-size: 13px;
      color: #6b7280;
    }
  </style>
</head>

<body>
  <div class="email-container">

    <div class="header">
      <div class="badge">Client: ${clientName}</div>
      <h2>🛠 Software Support Ticket Raised</h2>
    </div>

    <p>
      A support ticket has been raised from the client application via the in-app support widget.
      Below are the details provided by the user.
    </p>

    <div class="issue-box">
      <strong>📌 Reported Issue:</strong>
      <p style="margin-top:8px;"><strong>${issue}</strong></p>
    </div>

    <h3 class="section-title">👤 User Information</h3>
    <ul>
      <li><b>Name:</b> ${userInfo.userName}</li>
      <li><b>Email:</b> ${userInfo.email}</li>
      <li><b>Contact Number:</b> ${userInfo.contactNumber}</li>
    </ul>

    ${
      uploadedImageURL
        ? `
    <h3 class="section-title">📎 Attached Screenshot</h3>

    <div style="text-align:center;">
      <img src="${uploadedImageURL}" 
           alt="Issue Screenshot"
           class="preview-img" />

      <table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center" style="margin-top:15px;">
        <tr>
          <td align="center" bgcolor="#0d6efd" style="border-radius:8px;">
            <a href="${uploadedImageURL}" 
               target="_blank"
               style="
                 display:inline-block;
                 padding:12px 22px;
                 font-size:14px;
                 font-weight:600;
                 color:#ffffff;
                 text-decoration:none;
                 border-radius:8px;
                 font-family:Segoe UI,Roboto,Arial,sans-serif;
               ">
               🔍 View Full Screenshot
            </a>
          </td>

          <td width="12"></td>

          <td align="center" bgcolor="#198754" style="border-radius:8px;">
            <a href="${uploadedImageURL}" 
               download
               style="
                 display:inline-block;
                 padding:12px 22px;
                 font-size:14px;
                 font-weight:600;
                 color:#ffffff;
                 text-decoration:none;
                 border-radius:8px;
                 font-family:Segoe UI,Roboto,Arial,sans-serif;
               ">
               ⬇ Download File
            </a>
          </td>
        </tr>
      </table>
    </div>
    `
        : ""
    }

    <p style="margin-top:25px;">
      Please review and resolve the issue at the earliest. 
      You may reach out to the user directly if additional clarification is required.
    </p>

    <p>
      Regards,<br />
      <strong>Automated Support System</strong>
    </p>

    <div class="footer">
      © ${new Date().getFullYear()} Your Software Platform | Support Team
    </div>

  </div>
</body>
</html>
`;
}

export function patientConsentEmailTemplate(
  hospitalInfo: HospitalMasterDTO,
  patientData: any,
  consentLink: string,
): string {
  const patientName = `${patientData.firstName || ""} ${
    patientData.lastName || ""
  }`.trim();

  return `
  <div style="font-family: Arial, sans-serif; background:#f6f8fb; padding:24px;">
    <div style="max-width:720px; margin:auto; background:#ffffff; border-radius:16px; overflow:hidden; border:1px solid #e8ecf3;">
      
      <div style="background:linear-gradient(135deg,#011044,#ba025e); padding:24px; color:#ffffff;">
        <h2 style="margin:0; font-size:22px;">Patient Admission Consent</h2>
        <p style="margin:8px 0 0; font-size:14px;">
          Hospital Admission, Billing, Data Sharing and Finance Consent
        </p>
      </div>

      <div style="padding:24px;">
        <p>Dear ${patientName || "Patient"},</p>

        <p>
          Your patient registration has been created at 
          <strong>${hospitalInfo?.hospitalName || "Hospital"}</strong>.
        </p>

        <p>
          Please review and confirm your admission consent for hospital admission,
          billing, payment processing, Nishwik data sharing and EMI/loan assistance if selected.
        </p>

        <div style="background:#f8f9fc; border-left:4px solid #ba025e; padding:16px; border-radius:10px; margin:18px 0;">
          <p style="margin:0; line-height:1.6;">
            By signing this consent, you confirm that you understand and agree to the hospital admission process,
            treatment support, billing responsibility, deposit requirements, discharge clearance process,
            Nishwik data sharing and, if selected, loan/EMI processing terms.
          </p>
        </div>

        <div style="text-align:center; margin:28px 0;">
          <a href="${consentLink}"
             style="background:linear-gradient(135deg,#011044,#ba025e); color:#ffffff; text-decoration:none; padding:14px 28px; border-radius:10px; display:inline-block; font-weight:700;">
            Review & I Agree
          </a>
        </div>

        <p style="font-size:13px; color:#667085;">
          If the button does not work, copy and open this link in your browser:
        </p>

        <p style="font-size:13px; word-break:break-all; color:#011044;">
          ${consentLink}
        </p>

        <hr style="border:none; border-top:1px solid #edf0f7; margin:24px 0;" />

        <p style="font-size:12px; color:#667085; line-height:1.6;">
          This digital consent will be securely recorded with status, timestamp,
          device details and location where available.
        </p>

        <p style="margin-bottom:0;">
          Regards,<br/>
          <strong>Nishwik Healthcare</strong>
        </p>
      </div>
    </div>
  </div>
  `;
}

export function supportTicketEmailTemplate(
  supportModuleName: string,
  moduleName: string,
  ticketNo: string,
  raisedBy: string,
  category: string,
  issue: string,
  subject: string,
  description: string,
  endUserDesignation: string,
  adminListingUrl: string,
): string {
  return `
<!DOCTYPE html>

<html>

<body
  style="
    margin:0;
    padding:24px;
    background:#f4f7ff;
    font-family:Segoe UI,Arial,sans-serif;
    color:#333333;
  "
>

  <div
    style="
      max-width:700px;
      margin:auto;
      background:#ffffff;
      border-radius:14px;
      overflow:hidden;
      box-shadow:0 6px 18px rgba(0,0,0,0.08);
    "
  >

    <!-- HEADER -->

    <div
      style="
        background:#011044;
        color:#ffffff;
        padding:22px 28px;
      "
    >

      <h2
        style="
          margin:0;
          font-size:22px;
        "
      >
        ${supportModuleName} Support Ticket
      </h2>

      <p
        style="
          margin:7px 0 0;
          font-size:13px;
          opacity:0.85;
        "
      >
        A new support request has been submitted by
        ${endUserDesignation}.
      </p>

    </div>


    <!-- CONTENT -->

    <div
      style="
        padding:28px;
      "
    >

      <p
        style="
          margin-top:0;
          font-size:14px;
        "
      >
        Hello
        <strong>
          ${moduleName || supportModuleName}
        </strong>,
      </p>

      <p
        style="
          color:#5f6678;
          font-size:13px;
          line-height:1.6;
        "
      >
        A new support ticket has been raised.
        Please review the details below.
      </p>


      <!-- TICKET DETAILS -->

      <table
        style="
          width:100%;
          margin-top:22px;
          border-collapse:collapse;
          border:1px solid #eeeeee;
        "
      >

        <tbody>

          <tr>
            <td
              style="
                width:35%;
                padding:11px;
                border-bottom:1px solid #eeeeee;
                background:#f8f9fc;
                font-weight:600;
              "
            >
              Ticket Number
            </td>

            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
              "
            >
              ${ticketNo || "-"}
            </td>
          </tr>


          <tr>
            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
                background:#f8f9fc;
                font-weight:600;
              "
            >
              Raised By
            </td>

            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
              "
            >
              ${raisedBy || "-"}
            </td>
          </tr>


          <tr>
            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
                background:#f8f9fc;
                font-weight:600;
              "
            >
              Category
            </td>

            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
              "
            >
              ${category || "-"}
            </td>
          </tr>


          <tr>
            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
                background:#f8f9fc;
                font-weight:600;
              "
            >
              Issue
            </td>

            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
              "
            >
              ${issue || "-"}
            </td>
          </tr>


          <tr>
            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
                background:#f8f9fc;
                font-weight:600;
              "
            >
              Subject
            </td>

            <td
              style="
                padding:11px;
                border-bottom:1px solid #eeeeee;
              "
            >
              ${subject || "-"}
            </td>
          </tr>


          <tr>
            <td
              style="
                padding:11px;
                background:#f8f9fc;
                font-weight:600;
                vertical-align:top;
              "
            >
              Description
            </td>

            <td
              style="
                padding:11px;
                white-space:pre-wrap;
              "
            >
              ${description || "-"}
            </td>
          </tr>

        </tbody>

      </table>


      <!-- VIEW BUTTON -->

      <div
        style="
          margin-top:26px;
          text-align:center;
        "
      >

        <a
          href="${adminListingUrl}"
          target="_blank"
          style="
            display:inline-block;
            padding:12px 24px;
            border-radius:9px;
            background:#011044;
            color:#ffffff;
            font-size:13px;
            font-weight:700;
            text-decoration:none;
          "
        >
          View Support Ticket
        </a>

      </div>


      <!-- SIGNATURE -->

      <p
        style="
          margin-top:28px;
          margin-bottom:0;
          color:#454b5f;
          font-size:13px;
          line-height:1.6;
        "
      >
        Regards,
        <br />

        <strong>
          ${supportModuleName} Support
        </strong>
      </p>

    </div>

  </div>

</body>

</html>
`;
}